import React, { useState, useEffect, useRef } from 'react';
import Logo from '../images/logoGrandePreta.jpg';
import { usePDF } from 'react-to-pdf';
import BotaoGerarPDF from './GerarPDFComReactPDF';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { IoMdClose } from 'react-icons/io';
import { GoPlus } from 'react-icons/go';
import { FiEdit } from 'react-icons/fi';

import { MdOutlineDoNotDisturbAlt } from 'react-icons/md';

import Loading from './Loading';

import {
	requestClassByProtocol,
	requestSavedData,
	requestNewInvCreation,
	requestListNotesByProtocol,
	requestSaveForm,
	requestInvByProtocol,
	requestNewUnits,
	requestNoteTimeLine,
	requestNewClassCreation,
	requestInvConclude,
	requestNewAvalCreation,
	requestAvalList,
	requestUsersCnes,
	requestEmailSend,
	requestInvestigators,
	requestNeverevents,
	requestUnitSectors,
	requestEditSetor,
	requestPAUpdate,
} from '../services/requests';
import Json from '../utils/tipos_incidentes.json';
import { IoMdCheckmarkCircle } from 'react-icons/io';
import NeverJson from '../utils/never_events.json';
import tiposIncidentes from '../utils/tipos_incidentes.json';
import classificacoes from '../utils/classificacoes.json';
import { FaRegFilePdf } from 'react-icons/fa';
import Cookies from 'js-cookie';
import { set } from 'react-hook-form';

function ClassInvForm({ notificacao, cards }) {
	const [carregando, setCarregando] = useState(false);
	const [emailAlert, setEmailAlert] = useState(false);
	const [concluido, setConcluido] = useState(false);
	const [emailsList, setEmailsList] = useState([]);
	const [sendBox, setSendBox] = useState('');
	const [subReclassForm, setSubReclassForm] = useState('');
	const [reIncidentForm, setReIncidentForm] = useState('');
	const [reclassForm, setReclassForm] = useState('');
	const [reclass, setReclass] = useState(false);
	const [rejectCard, setRejectCard] = useState('');
	const [formSalvo, setFormSalvo] = useState(false);
	const [justificativa, setJustificativa] = useState('');
	const [noteId, setNoteId] = useState('');
	const [invAlert, setInvAlert] = useState(false);
	const [emailsLoad, setEmailsLoad] = useState(false);
	const [invId, setInvId] = useState('');
	const [invNamesList, setinvNamesList] = useState([]);
	const [pdfBaixado, setPdfBaixado] = useState(false);
	const [justAlert, setJustAlert] = useState(false);
	const [emailsAlert, setEmailsAlert] = useState(false);
	const [investigadorList, setInvestigadorList] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [concludeEmails, setConcludeEmails] = useState([]);
	const [rejeicao, setRejeicao] = useState('');
	const [textReject, setTextReject] = useState(false);
	const [invUsers, setInvUsers] = useState([]);
	const [validDate, setValidDate] = useState(true);
	const [alerta, setAlerta] = useState('');
	const [textBox, setTextBox] = useState(false);
	const [textBoxSend, setTextBoxSend] = useState(false);
	const [yesCheck, setYesCheck] = useState('');
	const [buttonLoading, setButtonLoading] = useState(false);
	const [formLayout, setFormLayout] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [enviado, setEnviado] = useState(false);
	const [copiado, setCopiado] = useState(false);
	const [counter, setCounter] = useState(1);
	const [cronCounter, setCronCounter] = useState(1);
	const [incident1Counter, setIncident1Counter] = useState(1);
	const [planCounter, setPlanCounter] = useState(1);
	const [isButtonEnabled, setIsButtonEnabled] = useState(true);
	const [emailCounter, setEmailCounter] = useState(1);
	const [noInvsAlert, setNoInvsAlert] = useState(false);
	const [concludeClass, setConcludeClass] = useState(false);
	const [concludeValue, setConcludeValue] = useState('');
	const [otherFinal, setOtherFinal] = useState('');

	const [unitSectors, setUnitSectors] = useState([]);
	const [editSetor, setEditSetor] = useState(false);
	const [open, setOpen] = useState(false);
	const [search, setSearch] = useState('');
	const [setorEdited, setSetorEdited] = useState('');
	const [editingPA, setEditingPA] = useState(null);
	const [autorized, setAutorized] = useState(true);

	const [editedSetorForm, setEditedSetorForm] = useState({
		setor_ocorrencia: '',
		setor_adequado: true,
	});

	const [invForm, setInvForm] = useState({
		coleta_dados: '',
		investigacao_concluida: false,
		equipe_investigacao_data: [
			{
				nome_completo: '',
				cargo: '',
				setor: '',
				email: '',
			},
		],
		cronologia_incidentes_data: [
			{
				evento: '',
				data: '',
				hora: '',
				setor: '',
				descricao: '',
			},
		],
		definicao_causas_data: {
			fator_paciente: '',
			fator_profissional: '',
			fator_tarefa: '',
			fator_comunicacao: '',
			fator_equipamento: '',
			fator_ambiente: '',
			fator_organizacional: '',
			fator_treinamento: '',
		},
		plano_acoes_data: [
			{
				causas_prioritarias: '',
				acoes_planejadas: '',
				responsavel: '',
				prazo: '',
				status: '',
			},
		],
	});

	const [finalForm, setFinalForm] = useState({
		investigacao: '',
		acoes_realizadas: '',
		padrao_trabalho: '',

		observacoes: '',
	});

	const [classForm, setClassForm] = useState({
		notificacao: '',
		classificacao: '',
		setor_adequado: true,
		setor_ocorrencia: '',
		sub_classificacao: '',
		prazo_investigacao: '',
	});

	const [form, setForm] = useState({
		unidade_token_notificacao: '',
		data_notificacao: '',
		data_ocorrencia: '',
		unidade: '',
		turno: '',
		setor: '',
		nome_paciente: '',
		sexo_paciente: '',
		nascimento_paciente: '',
		prontuario: '',
		notificador: '',
		notificador_cargo: '',
		notificador_setor: '',
		tipo_incidente: '',
		quem_presenciou: '',
		envolve_paciente: false,
		descricao_ocorrencia: '',
		acoes_imediatas: '',
		medida_preventiva: '',
		other_checked: false,
		fato_presenciado: false,
	});
	const [neverList, setNeverList] = useState([]);

	const formRef = useRef(null);

	const handleNeverEvents = async () => {
		if (Cookies.get('user')) {
			let result = await requestNeverevents(
				JSON.parse(Cookies.get('user')).token,
			);

			if (!result.error) {
				setNeverList(
					Object.entries(result.sub_classificacao).map(
						([id, obj]) => ({
							id: Number(id), // converte para número se quiser
							label: obj.label,
							nome: obj.nome,
							codigo: obj.codigo,
						}),
					),
				);
			}
		}
	};

	function formatDate(dataStr) {
		if (!dataStr) return '';
		const dataApenas = dataStr.split('T')[0];

		const [ano, mes, dia] = dataApenas.split('-');

		if (!ano || !mes || !dia) {
			return 'Data inválida';
		}

		return `${dia}/${mes}/${ano}`;
	}

	const handleReclassForm = (value) => {
		setReclassForm(value);
	};

	const handleReIncident = (value) => {
		setReIncidentForm(value);
	};

	const handleSubReclassForm = (event) => {
		if (reclass === 'false') {
			setReclassForm({ ...reclassForm, sub_classificacao: '' });
		} else {
			let value = event.target.value;
			setSubReclassForm(value);
		}
	};

	const handleEditSetor = async () => {
		try {
			const userCookie = Cookies.get('user');
			if (!userCookie) return;

			const { token } = JSON.parse(userCookie);
			if (!token || !notificacao?.protocolo) return;

			const result = await requestEditSetor(
				token,
				notificacao.protocolo,
				editedSetorForm,
			);

			return result;
		} catch (error) {
			console.error('Erro ao editar setor:', error);
		}
	};

	const handleConcludeClass = (valor) => {
		setConcludeClass(valor === 'nao' ? false : true);
	};

	const requestUsers = async () => {
		const user = JSON.parse(Cookies.get('user'));
		const unit_id = notificacao?.unidade_id;

		const investigators = await requestInvestigators(
			JSON.parse(Cookies.get('user')).token,
			notificacao.protocolo,
		);

		const users = await requestUsersCnes(
			JSON.parse(Cookies.get('user')).token,
			unit_id,
		);
		if (
			users &&
			user.cargo !== 'desenvolvedor' &&
			user.cargo !== 'gestor'
		) {
			let result = users.filter((user) =>
				user.perfil_unidades.some(
					(perfil) =>
						perfil.unidade_id.replace(/-/g, '') ===
							form.unidade_token_notificacao
								.split('')
								.reverse()
								.join('') &&
						perfil.ativo &&
						perfil.groups.includes('Investigadores'),
				),
			);
			if (result.length === 0) {
				setInvUsers(investigators);
			} else {
				setInvUsers(result);
			}
		}
		/* LOCAL PARA ADCIONAR UMA CONDIÇÃO PRA QUE QUANDO A UNIDADE NÃO TIVER NENHUM INVESTIGADOR QUE NAO SEJA GESTOR OU DESENVOLVEDOR O PROPRIO USUARIO SERA REFERENCIADO COMO INVESTIGADOR DESTINATARIO */
		if (investigators && user.cargo === 'gestor') {
			setInvUsers(investigators);
		}
		if (investigators && user.cargo === 'desenvolvedor') {
			let devUser = [
				{
					nome: user.nome,
					cargo: user.cargo,
					email: user.email,
					username: user.userName,
				},
				...investigators,
			];

			setInvUsers(devUser);
		}
	};

	const isRejected = async () => {
		const protocolo = notificacao.protocolo;
		const result = await requestNoteTimeLine(protocolo);
		if (!result.error) {
			if (
				(result.status === 'CONCLUIDO' &&
					result.data_avaliacao === null) ||
				result.status === 'CLASSIFICADO'
			) {
				setConcluido(true);
			}
		}
	};
	const setoresAlbert = [
		'Centro Cirúrgico',
		'CME',
		'UTI Pediátrico',
		'UI Adulto',
		'UTI Adulto',
		'UCINCO (UTI Neonatal)',
		'UI Neonatal',
		'Centro Obstétrico',
		'Obstetrícia',
		'Cirurgia Ginecológica',
		'Enfermaria de RN',
		'UCINCA Canguru',
		'Cirurgia Geral',
		'Cirurgia Vascular',
		'Clínica Médica',
		'Clínica Médica',
		'Ortopedia',
		'Pediatria',
		'UI Pediátrica',
		'Cirurgia Pediátrica',
	];

	const handleSectors = async () => {
		try {
			let unitId = notificacao?.unidade_id;

			// Se não tiver unitId, tenta buscar pela notificação
			if (!unitId) {
				const userCookie = Cookies.get('user');
				if (!userCookie || !notificacao?.protocolo) {
					setUnitSectors(setoresAlbert);
					return;
				}

				const { token } = JSON.parse(userCookie);
				if (!token) {
					setUnitSectors(setoresAlbert);
					return;
				}

				const note = await requestListNotesByProtocol(
					token,
					notificacao.protocolo,
				);

				unitId = note?.unidade_id;
			}

			// Se ainda não tem unitId, usa fallback
			if (!unitId) {
				setUnitSectors(setoresAlbert);
				return;
			}

			const sectors = await requestUnitSectors(unitId);

			if (Array.isArray(sectors) && sectors.length > 0) {
				setUnitSectors(sectors);
			} else {
				setUnitSectors(setoresAlbert);
			}
		} catch (error) {
			console.error('Erro ao carregar setores:', error);
			setUnitSectors(setoresAlbert);
		}
	};

	const handleSaveInv = async () => {
		setFormSalvo(false);
		setCarregando(true);
		setAlerta(''); // limpa antes de começar

		const token = JSON.parse(Cookies.get('user')).token;
		const id = invId;

		// helper para normalizar campos
		const normalizeField = (value) => {
			if (value === null || value === undefined) return 'NÃO PREENCHIDO';
			if (typeof value === 'string' && value.trim() === '')
				return 'NÃO PREENCHIDO';
			if (typeof value === 'number' && isNaN(value)) return 0;
			return value;
		};

		const equipe = Object.values(invForm.equipe_investigacao_data).map(
			(item) => ({
				investigacao: id,
				nome_completo: normalizeField(item.nome_completo),
				setor: normalizeField(item.setor),
				cargo: normalizeField(item.cargo),
				email:
					normalizeField(item.email) === 'NÃO PREENCHIDO'
						? 'emptyemail@gmail.com'
						: normalizeField(item.email),
			}),
		);

		const planos = Object.values(invForm.plano_acoes_data).map((item) => ({
			investigacao: id,
			causas_prioritarias: normalizeField(item.causas_prioritarias),
			acoes_planejadas: normalizeField(item.acoes_planejadas),
			responsabilidade: normalizeField(item.responsavel),
			// 👇 regra especial para prazo
			prazo:
				typeof item.prazo === 'string' && item.prazo.trim() === ''
					? 32767
					: normalizeField(item.prazo),
			status:
				normalizeField(item.status) === 'NÃO PREENCHIDO'
					? 'PENDENTE'
					: item.status?.toUpperCase() || '',
		}));

		const cronologia = Object.values(
			invForm.cronologia_incidentes_data,
		).map((item) => ({
			investigacao: id,
			evento: normalizeField(item.evento),

			data_evento:
				!item.data || item.data.trim() === ''
					? '2000-01-01' // data zerada
					: normalizeField(item.data),

			hora_evento:
				!item.hora || item.hora.trim() === ''
					? '00:00:00' // hora zerada
					: normalizeField(item.hora),

			local: normalizeField(item.setor),
			descricao: normalizeField(item.descricao),
		}));

		const definicao = invForm?.definicao_causas_data;
		const causas =
			definicao &&
			Object.values(definicao).some((val) => val && val.trim() !== '')
				? {
						investigacao: id,
						fatores_paciente: normalizeField(
							definicao.fator_paciente,
						),
						fatores_profissionais: normalizeField(
							definicao.fator_profissional,
						),
						fatores_tarefa: normalizeField(definicao.fator_tarefa),
						fatores_comunicacao: normalizeField(
							definicao.fator_comunicacao,
						),
						fatores_equipe: normalizeField(definicao.fator_equipe),
						fatores_ambiente: normalizeField(
							definicao.fator_ambiente,
						),
						fatores_organizacionais: normalizeField(
							definicao.fator_organizacional,
						),
						fatores_treinamento: normalizeField(
							definicao.fator_treinamento,
						),
						fatores_equipamento: normalizeField(
							definicao.fator_equipamento,
						),
					}
				: null;

		try {
			await requestSaveForm(token, id, 'equipe', equipe).catch(() => {
				setAlerta(
					'O bloco "Equipe de investigação" não foi salvo porque não está completamente preenchido.',
				);
			});

			await requestSaveForm(token, id, 'planos-acao', planos).catch(
				() => {
					setAlerta(
						'O bloco "Plano de Ação" não foi salvo porque não está completamente preenchido.',
					);
				},
			);

			await requestSaveForm(token, id, 'coleta-dados', {
				investigacao: id,
				dados_coletados: normalizeField(invForm.coleta_dados),
			}).catch(() => {
				setAlerta(
					'O bloco "Coleta de Dados" não foi salvo porque não está completamente preenchido.',
				);
			});

			await requestSaveForm(token, id, 'cronologia', cronologia).catch(
				() => {
					setAlerta(
						'O bloco "Cronologia de Incidentes" não foi salvo porque não está completamente preenchido.',
					);
				},
			);

			if (causas) {
				await requestSaveForm(token, id, 'causas', causas).catch(() => {
					setAlerta(
						'O bloco "Definição das Causas" não foi salvo porque não está completamente preenchido.',
					);
				});
			}
		} catch (error) {
			console.error('Erro ao salvar investigação:', error);
		} finally {
			setCarregando(false);
			setFormSalvo(true);
		}
	};

	const handleCopy = (event) => {
		const content = event?.target?.value; // Conteúdo específico
		navigator.clipboard
			.writeText(content)
			.then(() => {
				setCopiado(true);
			})
			.catch((err) => {
				console.error('Erro ao copiar:', err);
			});
	};

	const handleInvalid = async () => {
		// Se a textbox ainda não está visível, exibe ela e encerra a execução
		if (!textBox) {
			setTextBox(true);
			return;
		}

		if (notificacao.status !== 'NOTIFICADO') return;

		const isEmailEmpty = emailsList.length < 1;
		const isJustificativaEmpty = !justificativa.length;

		if (isEmailEmpty || isJustificativaEmpty) {
			isEmailEmpty && setEmailsAlert(true);
			isJustificativaEmpty && setJustAlert(true);
			return;
		}

		if (!window.confirm('Deseja realmente concluir esta notificação?'))
			return;

		const token = JSON.parse(Cookies.get('user')).token;

		let a = {
			...classForm,
			protocolo: notificacao.protocolo,
			descartar: true,
			justificativa_descarte: justificativa,
			investigadores_lista: invUsers
				.filter((o) => investigadorList.includes(o.email))
				.map((o) => o.username),
			prazo_investigacao: null,
		};

		const [emailResult, creationResult] = await Promise.all([
			requestEmailSend(token, {
				template_id: 3,
				destinatarios: concludeEmails,
				variaveis: {
					protocolo: notificacao.protocolo,
					observacao: justificativa,
					unidade: notificacao?.unidade_nome
						? notificacao?.unidade_nome
						: `unidade não informada`,
				},
			}),

			requestNewClassCreation(token, {
				protocolo: notificacao.protocolo,
				classificacao:
					concludeClass === true && concludeValue.length > 0
						? concludeValue
						: '',
				sub_classificacao: '',
				descartar: true,
				justificativa_descarte: justificativa,
				investigadores_lista: [],
				prazo_investigacao: null,
			}),
		]);

		emailResult && creationResult && handleGeneratePDF('conclusão');
	};

	const handleReject = async () => {
		const token = JSON.parse(Cookies.get('user')).token;

		const emails = await requestClassByProtocol(
			token,
			notificacao.protocolo,
		);
		if (textReject === false) {
			setTextReject(true);
		} else if (notificacao.status === 'INVESTIGADO') {
			if (rejeicao.length === 0) {
				setTextReject(true);
			} else {
				let a = {
					investigacao: invId,
					decisao: 'REJEITADA',
					acoes_realizadas: false,
					pontos_trabalho: false,
					padrao_trabalho: false,
					observacoes: finalForm.observacoes,
					tipo_incidente_adequado: true,
					classificacao_adequada: true,
					motivo_rejeicao: rejeicao,
				};
				if (textReject === true) {
					setRejectCard('clicked');
					if (rejectCard === 'clicked') {
						const response = await requestNewAvalCreation(
							JSON.parse(Cookies.get('user')).token,
							a,
						);
						/* 	console.log(response);
						console.log('teile'); */
						/* const prodToken =
							'81eedc273fd7f14c01edd98a75529a94e6563c06';
						const resulter = await requestEmailSend(prodToken, {
							template_id: 4,
							destinatarios:
								emails.investigadores.map((item) => item.email)
									?.length > 0
									? emails.investigadores.map(
											(item) => item.email
									  )
									: [],
							variaveis: {
								protocolo: notificacao.protocolo,
								justificativa: rejeicao,
								unidade: notificacao?.unidade_nome
									? notificacao?.unidade_nome
									: `unidade não informada`,
							},
						}); */

						if (!response.error) {
							setRejectCard('send');
						}
					}
				}
			}
		}
	};

	const handleGeneratePDF = (param) => {
		setFormLayout(true);
		const input = formRef.current;

		// Ajusta layout fixo para captura
		input.style.width = '1236px';
		input.style.minHeight = '1123px';

		let blocks = ['block1', 'block2', 'block3', 'block4'];
		if (
			param === 'conclusão' &&
			(notificacao?.status === 'NOTIFICADO' ||
				notificacao?.status === 'CLASSIFICADO')
		) {
			blocks = ['block1'];
		} else if (
			notificacao?.status === 'NOTIFICADO' ||
			notificacao?.status === 'CLASSIFICADO'
		) {
			blocks = ['block1', 'block2'];
		}

		const margin = 10;
		const spacing = 4;
		const pdf = new jsPDF('p', 'mm', 'a4');
		const pageHeight = pdf.internal.pageSize.height - 2 * margin;
		let currentY = margin;

		const loadImages = async (element) => {
			const images = element.getElementsByTagName('img');
			const promises = [...images].map((img) => {
				return new Promise((resolve) => {
					if (img.complete) resolve();
					else img.onload = img.onerror = resolve;
				});
			});
			await Promise.all(promises);
		};

		const renderSection = async (section) => {
			await loadImages(section);

			const canvas = await html2canvas(section, {
				scale: 2,
				useCORS: true,
			});

			const imgData = canvas.toDataURL('image/jpeg', 1);
			const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
			const canvasWidth = canvas.width;
			const canvasHeight = canvas.height;
			const imgHeight = (canvasHeight * pdfWidth) / canvasWidth;

			// 👉 Cabe inteiro em uma página
			if (imgHeight <= pageHeight) {
				// 👉 Não cabe no espaço restante → vai pra próxima página
				if (currentY + imgHeight > pageHeight) {
					pdf.addPage();
					currentY = margin;
				}

				pdf.addImage(
					imgData,
					'JPEG',
					margin,
					currentY,
					pdfWidth,
					imgHeight,
				);
				currentY += imgHeight + spacing;
				return;
			}

			// 🔥 Section maior que uma página → fatiar
			let position = 0;
			const pageCanvas = document.createElement('canvas');
			const pageCtx = pageCanvas.getContext('2d');

			const pageCanvasHeight = Math.floor(
				(canvasWidth * pageHeight) / pdfWidth,
			);

			pageCanvas.width = canvasWidth;

			while (position < canvasHeight) {
				const sliceHeight = Math.min(
					pageCanvasHeight,
					canvasHeight - position,
				);

				pageCanvas.height = sliceHeight;
				pageCtx.clearRect(0, 0, pageCanvas.width, pageCanvas.height);

				pageCtx.drawImage(
					canvas,
					0,
					position,
					canvasWidth,
					sliceHeight,
					0,
					0,
					canvasWidth,
					sliceHeight,
				);

				const pageData = pageCanvas.toDataURL('image/jpeg', 1);
				const sliceImgHeight = (sliceHeight * pdfWidth) / canvasWidth;

				pdf.addPage();
				pdf.addImage(
					pageData,
					'JPEG',
					margin,
					margin,
					pdfWidth,
					sliceImgHeight,
				);

				currentY = margin + sliceImgHeight + spacing;
				position += sliceHeight;
			}
		};

		const renderBlock = async (blockId) => {
			const block = document.getElementById(blockId);
			if (!block) return;

			const sections = Array.from(block.children);
			for (const section of sections) {
				await renderSection(section);
			}
		};

		const renderFirstBlock = async (blockId) => {
			const block = document.getElementById(blockId);
			if (!block) return;

			await loadImages(block);
			const canvas = await html2canvas(block, {
				scale: 2,
				useCORS: true,
			});

			const imgData = canvas.toDataURL('image/jpeg', 1);
			const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
			const canvasWidth = canvas.width;
			const canvasHeight = canvas.height;
			const imgHeight = (canvasHeight * pdfWidth) / canvasWidth;

			pdf.addImage(imgData, 'JPEG', margin, margin, pdfWidth, imgHeight);
			currentY = imgHeight + margin + spacing;
		};

		const generatePDF = async () => {
			await new Promise((resolve) => setTimeout(resolve, 300));

			await renderBlock(blocks[0]);
			for (let i = 1; i < blocks.length; i++) {
				await renderBlock(blocks[i]);
			}

			if (param === 'download') {
				pdf.save(`${notificacao?.protocolo}.pdf`);
			}

			const pdfBlob = pdf.output('blob');
			const pdfUrl = URL.createObjectURL(pdfBlob);
			document.cookie = `pdfUrl=${pdfUrl}; max-age=86400; path=/`;

			setFormLayout(false);
			input.style.width = '';
			input.style.minHeight = '';

			setTimeout(() => {
				if (param !== 'download') setEnviado(true);
				setButtonLoading(false);
			}, 500);
		};

		setTimeout(() => {
			generatePDF();
			setButtonLoading(true);
		}, 500);
	};

	const handleDownloadPDF = () => {
		const pdfUrl = localStorage.getItem('pdfUrl') || getCookie('pdfUrl');
		if (pdfUrl) {
			const link = document.createElement('a');
			link.href = pdfUrl;
			link.download = `${notificacao?.protocolo}.pdf`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	};

	const handleEmails = (indice, valor) => {
		setConcludeEmails([valor]);
	};

	const addConcludes = () => {
		const email = concludeEmails[0];

		// Expressão regular para validar e-mails
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		// Verificações
		const isValidEmail = emailRegex.test(email);
		const isNotEmpty = email?.trim() !== '';

		if (
			email &&
			isNotEmpty &&
			isValidEmail &&
			emailsList.length < 5 &&
			!emailsList.includes(email)
		) {
			setIsLoading(true);

			setTimeout(() => {
				const newList = [...emailsList, email];
				setEmailsList(newList);
				setIsLoading(false);
			}, 1000);
		}
	};

	const removeEmail = (email, index) => {
		let newEmailsList = emailsList;
		let teilezaga = newEmailsList.filter((item) => item !== email);

		setEmailsList(teilezaga);
	};

	// Função para recuperar cookie
	const getCookie = (name) => {
		const cookies = document.cookie.split('; ');
		const cookie = cookies.find((row) => row.startsWith(name));
		return cookie ? cookie.split('=')[1] : null;
	};

	const handleFinal = (chave, valor) => {
		let prev = finalForm;
		let acoes;
		valor === 'sim' ? (acoes = true) : (acoes = false);

		let padroes;
		valor === 'sim' ? (padroes = true) : (padroes = false);
		if (chave === 'acoes_realizadas') {
			setFinalForm((prevFormData) => ({
				...prevFormData,
				acoes_realizadas: acoes,
			}));
			sendButtonEnabled({
				...prev,
				acoes_realizadas: acoes,
			});
		}

		if (chave === 'observacoes') {
			setFinalForm((prevFormData) => ({
				...prevFormData,
				observacoes: valor,
			}));
			/* sendButtonEnabled({
				...prev,
				observacoes: valor,
			}); */
		}

		if (chave === 'padroes_trabalho') {
			setFinalForm((prevFormData) => ({
				...prevFormData,
				padrao_trabalho: padroes,
			}));
			sendButtonEnabled({
				...prev,
				padrao_trabalho: padroes,
			});
		}
	};

	const moment = require('moment');
	require('moment/locale/pt-br');
	moment.locale('pt-br');

	/* const incidentTypes = [
		'Falha na identificação do paciente',
		'Falha na terapia medicamentosa',
		'Falha na segurança cirúrgica',
		'Queda ou quase queda do paciente',
		'Lesão por pressão adquirida após admissão do paciente',
		'Reações transfusionais ou falhas com hemocomponentes',
		'Incidente envolvendo a dieta',
		'Falha no transporte/transferência do paciente',
		'Falha relacionada ao uso de gases/oxigênio/vapor',
		'Falha relacionada a exames e/ou diagnósticos',
		'Falha operacional de equipamentos ou dispositivos médicos',
		'Falha relacionada à infraestrutura, edifício ou instalações',
		'Falhas na comunicação e/ou documentação',
		'Contenção, suicídio ou dano autoinfligido',
		'Evasão de paciente',
	]; */

	const handleForm = (value, id) => {
		const findValueFromDisplay = (displayValue) => {
			let word = displayValue.trim();
			const result = Json.find((item) => item.display === word);
			return result ? result.value : '';
		};

		if (id === 'tipo_incidente') {
			setForm((prevForm) => ({
				...prevForm,
				tipo_incidente: findValueFromDisplay(value),
			}));
		} else {
			setForm((prevForm) => ({ ...prevForm, [id]: value }));
		}
	};

	const isFormValid = () => {
		return Object.entries(form).every(
			([key, value]) =>
				[
					'nome_paciente',
					'sexo_paciente',
					'nascimento_paciente',
					'notificador',
				].includes(key) || value !== '',
		);
	};

	const removeInv = (item, index) => {
		if (investigadorList.length > 0) {
			let emails = investigadorList;
			let nomes = invNamesList;

			let newEmails = emails.filter((_, i) => i !== index);
			let newNomes = nomes.filter((_, i) => i !== index);

			setInvestigadorList(newEmails);
			setinvNamesList(newNomes);
			setIsLoading(true);
			setTimeout(() => {
				setIsLoading(false);
			}, 1000);
		}
	};

	const handleSubmit = async () => {
		if (notificacao.status === 'NOTIFICADO') {
			if (textBoxSend === true) {
				if (!isButtonEnabled) {
					if (yesCheck && investigadorList.length > 0) {
						let a = {
							...classForm,
							protocolo: notificacao.protocolo,
							descartar: false,
							motivo_descarte: false,
							justificativa_descarte: '',
							investigadores_lista: invUsers
								.filter((o) =>
									investigadorList.includes(o.email),
								)
								.map((o) => o.username),
							prazo_investigacao:
								classForm.classificacao === 'OBITO' ||
								classForm.classificacao === 'GRAVE' ||
								(classForm.classificacao === 'NEVER_EVENTS' &&
									classForm.sub_classificacao.length > 0)
									? null
									: classForm.prazo_investigacao,
						};

						const result = await requestNewClassCreation(
							JSON.parse(Cookies.get('user')).token,
							a,
						);
						if (!result.error) {
							setButtonLoading(true);
							setIsButtonEnabled(true);
							/* const emailSend = await requestEmailSend(
								JSON.parse(Cookies.get('user')).token,
								{
									template_id: 2,
									destinatarios: 'abacuque.parto@gmail.com',
									variaveis: {
										nome: 'Investigador(a)',
										protocolo: notificacao.protocolo,
										prazo: classForm.prazo_investigacao,
										classificacao: classForm.classificacao,
										unidade: notificacao?.unidade_nome
											? notificacao?.unidade_nome
											: `unidade não informada`,
									},
								}
							);
							if (emailSend.error) {
							
								return;
							} */
							handleGeneratePDF();
							console.log('Formulário classificado com sucesso');
						} else {
							console.log(result?.error);
							return;
						}
					} else if (yesCheck && investigadorList.length === 0) {
						setInvAlert(true);
						setSendBox(true);
					}
				}
			} else {
				setYesCheck(true);
				setSendBox(true);
				requestUsers();
				setTextBoxSend(true);
			}
		}
		if (notificacao.status === 'CLASSIFICADO') {
			await handleSaveInv(); // Aguarda a finalização de handleSaveInv antes de continuar
			if (!sendButtonEnabled()) {
				const result = await requestInvConclude(
					JSON?.parse(Cookies?.get('user'))?.token,
					invId,
					{
						id: invId,
					},
				);
				if (result.error) {
					console.log(result.error);
					return;
				} else {
					console.log('Formulário Investigado com sucesso');
					handleGeneratePDF();
					/* setEnviado(true); meireles*/
				}
			}
		}

		if (notificacao.status === 'INVESTIGADO') {
			if (!sendButtonEnabled()) {
				if (
					reclass === true &&
					(reclassForm.length === 0 ||
						(reclassForm === 'NEVER_EVENTS' &&
							subReclassForm.length === 0) ||
						(reclassForm === '' && subReclassForm.length > 0) ||
						reIncidentForm.length === 0 ||
						(reIncidentForm === 'OUTROS' && otherFinal === ''))
				) {
					console.log(
						'Erro ao avaliar o formulário: reclassificação ou reclassificação de incidente inválida.',
					);
				} else {
					const result = await requestNewAvalCreation(
						JSON.parse(Cookies.get('user')).token,
						{
							investigacao: invId,
							decisao: 'ACEITA',
							acoes_realizadas: finalForm?.acoes_realizadas,
							pontos_trabalho: finalForm?.padrao_trabalho,
							padrao_trabalho: finalForm?.padrao_trabalho,
							observacoes: finalForm?.observacoes,
							motivo_rejeicao: '',
							classificacao_adequada: !reclass,
							classificacao_final: reclass ? reclassForm : '',
							sub_classificacao_final: subReclassForm,
							tipo_incidente_adequado: !reclass,
							tipo_incidente_final: reclass ? reIncidentForm : '',
							tipo_incidente_final_outros:
								reIncidentForm === 'OUTROS' ? otherFinal : '',
						},
					);

					if (result.error) {
						console.log(result.error);
						return;
					} else {
						console.log('Formulário Avaliado com sucesso');
						handleGeneratePDF();
						/* setEnviado(true); */
					}
				}
			}
		}
	};
	const handleColeta = (id, nome, valor) => {
		let key = nome;
		let value = valor;
		let prevForm = invForm;
		prevForm[key] = value;
		setInvForm(prevForm);
		sendButtonEnabled();
	};

	const handleInvSelected = (email, nome) => {
		if (email !== '') {
			if (
				investigadorList.length < 5 &&
				!investigadorList.includes(email)
			) {
				let b = invNamesList;
				b.push(nome);
				setinvNamesList(b);

				let a = investigadorList;
				a.push(email);
				setInvestigadorList(a);
			}
		}
	};

	const addInv = () => {
		setIsLoading(true);
		setTimeout(() => {
			setIsLoading(false);
		}, 1000);
	};

	const setUnitToken = async () => {
		const units = await requestNewUnits();
		const unit = units.find(
			(unit) =>
				decodeURIComponent(
					String(window.location.pathname).split('/')[2],
				) === unit.nome,
		);
		setForm((prevForm) => ({
			...prevForm,
			unidade_token_notificacao: unit.token_notificacao,
		}));
	};

	/* 
NÃO MEXER NESSA LOGICA PRA NAO QUEBRAR AS REGRAS */
	const canEnableButton = (form) => {
		// REGRA SETOR
		if (form.setor_adequado === true && form.setor_ocorrencia) {
			return false;
		}

		if (form.setor_adequado === false && !form.setor_ocorrencia) {
			return false;
		}

		// REGRA CLASSIFICAÇÃO
		if (
			(form.classificacao === 'GRAVE' ||
				form.classificacao === 'OBITO') &&
			!form.prazo_investigacao
		) {
			return false;
		}

		if (form.classificacao === 'NEVER_EVENTS' && !form.prazo_investigacao) {
			return false;
		}

		// REGRA SUBCLASSIFICAÇÃO (se existir)
		if (
			form.classificacao &&
			form.classificacao !== 'GRAVE' &&
			form.classificacao !== 'OBITO' &&
			!form.sub_classificacao
		) {
			return false;
		}

		return true;
	};

	const handleClassForm = (event) => {
		setTextBoxSend(false);
		const { id, value } = event.target;
		let prev = classForm;

		/* if (id === 'setor_ocorrencia') {
			setClassForm((prevFormData) => {
				const updated = {
					...prevFormData,
					setor_ocorrencia: value,
					setor_adequado: false,
				};
				
				if (!updated.setor_adequado && !updated.setor_ocorrencia) {
					setIsButtonEnabled(false);
				} else {
					setIsButtonEnabled(true);
				}

				sendButtonEnabled(updated);
				return updated;
			});
		}

		if (id === 'setor_adequado') {
			setClassForm((prevFormData) => {
				const updated = {
					...prevFormData,
					setor_adequado: value,
					setor_ocorrencia: value
						? ''
						: prevFormData.setor_ocorrencia,
				};

			
				if (
					updated.setor_adequado === false &&
					!updated.setor_ocorrencia
				) {
					setIsButtonEnabled(false);
				} else {
					setIsButtonEnabled(true);
				}

				sendButtonEnabled(updated);
				return updated;
			});
		} */

		if (id === 'classificacao' && value !== 'NEVER_EVENTS') {
			if (value === 'GRAVE' || value === 'OBITO') {
				const dataFutura = new Date();
				dataFutura.setDate(dataFutura.getDate() + 2);

				const prazoInvestigacao = dataFutura
					.toLocaleDateString('pt-BR')
					.split('/')
					.join('-');

				setClassForm((prevFormData) => ({
					...prevFormData,
					[id]: value,
					sub_classificacao: '',
					prazo_investigacao: prazoInvestigacao,
				}));
				setValidDate(false);
			} else {
				setClassForm((prevFormData) => ({
					...prevFormData,
					[id]: value,
					sub_classificacao: '',
					prazo_investigacao: '',
				}));
				sendButtonEnabled({
					...prev,
					[id]: value,
					sub_classificacao: '',
					prazo_investigacao: '',
				});
				setIsButtonEnabled(true);
			}
		}

		if (id === 'prazo_investigacao') {
			const selectedDate = new Date(value);
			const today = new Date();
			today.setHours(0, 0, 0, 0);

			if (selectedDate <= today) {
				setClassForm((prevFormData) => ({
					...prevFormData,
					[id]: value,
				}));
				setValidDate(true);
				sendButtonEnabled(
					{
						...prev,
						[id]: value,
					},
					true,
				);
			} else {
				setValidDate(false);
				setClassForm((prevFormData) => ({
					...prevFormData,
					[id]: value,
				}));
				sendButtonEnabled(
					{
						...prev,
						[id]: value,
					},
					false,
				);
			}
		} else {
			if (id === 'classificacao' && value === 'NEVER_EVENTS') {
				const dataFutura = new Date();
				dataFutura.setDate(dataFutura.getDate() + 2);

				const prazoInvestigacao = dataFutura
					.toLocaleDateString('pt-BR')
					.split('/')
					.join('-');

				setClassForm((prevFormData) => ({
					...prevFormData,
					[id]: value,
					sub_classificacao: '',
					prazo_investigacao: prazoInvestigacao,
				}));
				sendButtonEnabled({
					...prev,
					[id]: value,
				});

				setValidDate(false);
			} else {
				if (value === 'OBITO' || value === 'GRAVE') {
					setIsButtonEnabled(false);
				} else if (id === 'sub_classificacao') {
					setClassForm((prevFormData) => ({
						...prevFormData,
						[id]: value,
					}));
					sendButtonEnabled({
						...prev,
						[id]: value,
					});
				} else {
					setIsButtonEnabled(true);
				}
			}
		}

		if (id === 'setor_ocorrencia') {
			prev.setor_adequado === false && value.length === 0
				? setSetorEdited(false)
				: setSetorEdited(true);
		} else {
			prev.setor_adequado === false && prev.setor_ocorrencia.length === 0
				? setSetorEdited(false)
				: setSetorEdited(true);
		}
	};

	const handleEquipe = (id, nome, valor) => {
		let position = id.split('/')[0].trim();
		let object = id.split('/')[1].trim();
		let key = nome;
		let value = valor;
		setFormSalvo(false);

		let prevForm = invForm;
		prevForm[object][position][key] = value;
		setInvForm(prevForm);
		sendButtonEnabled();
	};
	const addEquipe = (id) => {
		if (id === 'adcionar') {
			setCounter(counter + 1);
			let newForm = invForm;
			newForm.equipe_investigacao_data.push({
				nome_completo: '',
				cargo: '',
				setor: '',
				email: '',
			});
			setInvForm(newForm);
		}
		if (id === 'remover') {
			if (counter > 1) {
				setCounter(counter - 1);
				let newForm = invForm;
				newForm.equipe_investigacao_data.pop();
			}
		}
		sendButtonEnabled();
	};

	const handleCronologia = (id, nome, valor) => {
		let position = id.split('/')[0].trim();
		let object = id.split('/')[1].trim();
		let key = nome;
		let value = valor;
		setFormSalvo(false);

		let prevForm = invForm;
		prevForm[object][position][key] = value;
		setInvForm(prevForm);
		sendButtonEnabled();
	};
	const addCronologia = (id) => {
		if (id === 'adcionar') {
			setCronCounter(cronCounter + 1);
			let newForm = invForm;
			newForm.cronologia_incidentes_data.push({
				evento: '',
				data: '',
				hora: '',
				setor: '',
				descricao: '',
			});
			setInvForm(newForm);
			sendButtonEnabled();
		}
		if (id === 'remover') {
			if (cronCounter > 1) {
				setCronCounter(cronCounter - 1);
				let newForm = invForm;
				newForm.cronologia_incidentes_data.pop();
				sendButtonEnabled();
			}
		}
	};

	const handlePlano = (id, nome, valor) => {
		let position = id.split('/')[0].trim();
		let object = id.split('/')[1].trim();
		let key = nome;
		let value = valor;
		setFormSalvo(false);

		let prevForm = invForm;

		prevForm[object][position][key] = value;
		setInvForm(prevForm);
		sendButtonEnabled();
	};
	const addPlano = (id) => {
		if (id === 'adcionar') {
			setPlanCounter(planCounter + 1);
			let newForm = invForm;

			newForm.plano_acoes_data.push({
				causas_prioritarias: '',
				acoes_planejadas: '',
				responsavel: '',
				prazo: '',
				status: '',
			});

			setInvForm(newForm);
			sendButtonEnabled();
		}
		if (id === 'remover') {
			if (planCounter > 1) {
				setPlanCounter(planCounter - 1);
				let newForm = invForm;
				newForm.plano_acoes_data.pop();
				sendButtonEnabled();
			}
		}
	};
	const handleCausas = (id, nome, valor) => {
		const position = id.split('/')[0].trim();
		const object = id.split('/')[1].trim();
		const key = nome;
		const value = valor;

		setFormSalvo(true);

		setInvForm((prevForm) => ({
			...prevForm,
			[object]: {
				...prevForm[object],
				[key]: value,
			},
		}));

		sendButtonEnabled(true);
	};

	/* const addCausas = (id) => {
		if (id === 'adcionar') {
			setCronCounter(cronCounter + 1);
			let newForm = invForm;
			newForm.cronologia_incidentes_data.push({
				nome_completo: '',
				cargo: '',
				setor: '',
				email: '',
			});
			setInvForm(newForm);
		}
		if (id === 'remover') {
			if (cronCounter > 1) {
				setCronCounter(cronCounter - 1);
				let newForm = invForm;
				newForm.cronologia_incidentes_data.pop();
			}
		}
	}; */

	const hasEmptyFields = (obj) => {
		for (const key in obj) {
			// Ignora a validação do campo definicao_causas_data
			if (key === 'definicao_causas_data') continue;

			const value = obj[key];

			// Validação especial para cronologia_incidentes_data
			if (key === 'cronologia_incidentes_data' && Array.isArray(value)) {
				for (const item of value) {
					if (!item?.descricao || item.descricao.trim().length < 5) {
						return true; // Campo descricao vazio ou com menos de 10 caracteres
					}
				}
			}

			// Verifica valores vazios, null ou undefined
			if (value === '' || value === null || value === undefined) {
				return true;
			}

			// Verifica arrays recursivamente
			if (Array.isArray(value)) {
				for (const item of value) {
					if (hasEmptyFields(item)) return true;
				}
			}

			// Verifica objetos aninhados recursivamente
			if (
				typeof value === 'object' &&
				value !== null &&
				!Array.isArray(value)
			) {
				if (hasEmptyFields(value)) return true;
			}
		}

		return false; // Nenhum campo inválido encontrado
	};

	const sendButtonEnabled = (data) => {
		if (notificacao?.status === 'NOTIFICADO') {
			const { classificacao, sub_classificacao, prazo_investigacao } =
				data;
			if (!prazo_investigacao || !classificacao) {
				if (
					classificacao === 'GRAVE' ||
					classificacao === 'OBITO' ||
					(classificacao === 'NEVER_EVENTS' &&
						sub_classificacao.length > 0)
				) {
					return setIsButtonEnabled(false);
				}
				return setIsButtonEnabled(true);
			} else if (classificacao === 'NEVER_EVENTS' && !sub_classificacao) {
				return setIsButtonEnabled(true);
			} else if (
				classificacao !== 'NEVER_EVENTS' &&
				sub_classificacao === '' &&
				new Date(prazo_investigacao) > new Date()
			) {
				return setIsButtonEnabled(false);
			} else if (
				classificacao !== 'NEVER_EVENTS' &&
				sub_classificacao !== ''
			) {
				return setIsButtonEnabled(true);
			} else {
				if (new Date(prazo_investigacao) > new Date()) {
					return setIsButtonEnabled(false);
				} else {
					if (
						classificacao === 'OBITO' ||
						classificacao === 'GRAVE' ||
						(classificacao === 'NEVER_EVENTS' &&
							sub_classificacao.length > 0)
					) {
						setIsButtonEnabled(false);
						return setIsButtonEnabled(false);
					}
					return setIsButtonEnabled(true);
				}
			}
		}
		if (notificacao.status === 'CLASSIFICADO') {
			/* if (invForm?.cronologia_incidentes_data?.descricao.length >= 10) { */
			return setIsButtonEnabled(hasEmptyFields(invForm));
			/* 	} */
		}
		if (notificacao.status === 'INVESTIGADO') {
			if (data) {
				let verify = Object.entries(data).every(
					([key, value]) =>
						key === 'investigacao' ||
						key === 'observacoes' ||
						(value !== null && value !== undefined && value !== ''),
				);

				return setIsButtonEnabled(!verify);
			}
		}
	};

	const listAval = async () => {
		let result = await requestAvalList(
			JSON.parse(Cookies.get('user')).token,
		);
		if (result.length > 0) {
			let marcos = result.filter(
				(item) => item.protocolo === notificacao.protocolo,
			)[0];

			if (
				marcos?.classificacao_final !== '' ||
				marcos?.tipo_incidente_final !== ''
			) {
				setReclass(true);
				setFinalForm({
					investigacao: marcos?.investigacao,
					acoes_realizadas: marcos?.acoes_realizadas,
					padrao_trabalho: marcos?.padrao_trabalho,
					observacoes: marcos?.observacoes,
					classificacao_final: marcos?.classificacao_final,
					sub_classificacao_final: marcos?.sub_classificacao_final,
					tipo_incidente_final: marcos?.tipo_incidente_final,
					tipo_incidente_final_outros:
						marcos?.tipo_incidente_final_outros,
				});
			} else {
				setFinalForm({
					investigacao: marcos?.investigacao,
					acoes_realizadas: marcos?.acoes_realizadas,
					padrao_trabalho: marcos?.padrao_trabalho,
					observacoes: marcos?.observacoes,
				});
			}
		}
	};
	// Função para normalizar valores retornados
	const normalizeEmptyValue = (value) => {
		if (
			value === 'NÃO PREENCHIDO' ||
			value === '00:00:00' ||
			value === '2000-01-01' ||
			value === null ||
			value === undefined
		) {
			return '';
		}
		return value;
	};

	const handleEditPAStatus = async (id) => {
		const result = await requestPAUpdate(
			JSON.parse(Cookies.get('user')).token,
			{
				status: invForm.plano_acoes_data.find((item) => item.id === id)
					.status,
			},
			id,
		);

		if (result.error) {
			window.alert(
				'Erro ao atualizar o status do plano de ação, tente novamente mais tarde.',
			);
		}
	};

	const perRequest = async () => {
		const token = JSON.parse(Cookies.get('user')).token;
		const newForm = await requestListNotesByProtocol(
			token,
			notificacao.protocolo,
		);

		if (!newForm.error) {
			setForm({
				...form,
				envolve_paciente: normalizeEmptyValue(newForm.envolve_paciente),
				quem_presenciou: normalizeEmptyValue(newForm.quem_presenciou),
				nome_paciente: normalizeEmptyValue(newForm.nome_paciente),
				sexo_paciente: normalizeEmptyValue(newForm.sexo_paciente),
				nascimento_paciente: normalizeEmptyValue(
					newForm.nascimento_paciente,
				),
				prontuario: normalizeEmptyValue(newForm.prontuario),
			});
		}

		const result = await requestClassByProtocol(
			token,
			notificacao.protocolo,
		);
		const inv = await requestNewInvCreation(token, notificacao?.protocolo);

		setAutorized(inv?.error?.message.includes('403') ? false : true);

		const InvByProtocol = await requestInvByProtocol(
			token,
			result.protocolo,
		);

		let correctId;
		if (inv.error) {
			if (!InvByProtocol.error) {
				correctId = InvByProtocol[0]?.id;
				setInvId(correctId);
			} else {
				setInvId(inv.id);
			}
		} else {
			setInvId(inv?.id);
			correctId = inv.id;
		}

		if (correctId !== undefined) {
			const equipe = await requestSavedData(token, correctId, 'equipe');
			const planos = await requestSavedData(
				token,
				correctId,
				'planos-acao',
			);
			const cronologia = await requestSavedData(
				token,
				correctId,
				'cronologia',
			);
			const causas = await requestSavedData(token, correctId, 'causas');
			const coleta = await requestSavedData(
				token,
				correctId,
				'coleta-dados',
			);

			// Coleta de dados
			if (coleta?.length > 0) {
				setInvForm((prevForm) => ({
					...prevForm,
					coleta_dados: normalizeEmptyValue(
						coleta[0]?.dados_coletados,
					),
				}));
			}

			// Equipe de investigação
			if (equipe?.length > 0) {
				setCounter(equipe?.length);
				setInvForm((prevForm) => ({
					...prevForm,
					equipe_investigacao_data: equipe.map((membro) => ({
						nome_completo: normalizeEmptyValue(
							membro.nome_completo,
						),
						cargo: normalizeEmptyValue(membro.cargo),
						setor: normalizeEmptyValue(membro.setor),
						email: normalizeEmptyValue(membro.email),
					})),
				}));
			}

			// Planos de ação

			if (planos?.length > 0) {
				setPlanCounter(planos?.length);
				setInvForm((prevForm) => ({
					...prevForm,
					plano_acoes_data: planos.map((plano) => ({
						causas_prioritarias: normalizeEmptyValue(
							plano.causas_prioritarias,
						),
						acoes_planejadas: normalizeEmptyValue(
							plano.acoes_planejadas,
						),
						responsavel: normalizeEmptyValue(
							plano.responsabilidade,
						),
						prazo: normalizeEmptyValue(
							plano.prazo === 32767 ? '' : plano.prazo,
						),
						status: normalizeEmptyValue(plano.status),
						id: normalizeEmptyValue(plano.id),
					})),
				}));
			}

			// Cronologia do incidente (ordenada por ID)
			if (cronologia?.length > 0) {
				setCronCounter(cronologia?.length);
				const cronologiaOrdenada = [...cronologia].sort(
					(a, b) => a.id - b.id,
				);

				setInvForm((prevForm) => ({
					...prevForm,
					cronologia_incidentes_data: cronologiaOrdenada.map(
						(cron) => ({
							evento: normalizeEmptyValue(cron.evento),
							hora: normalizeEmptyValue(cron.hora_evento),
							data: normalizeEmptyValue(cron.data_evento),
							setor: normalizeEmptyValue(cron.local),
							descricao: normalizeEmptyValue(cron.descricao),
						}),
					),
				}));
			}

			// Definição de causas
			if (causas?.length > 0) {
				setInvForm((prevForm) => ({
					...prevForm,
					definicao_causas_data: {
						fator_paciente: normalizeEmptyValue(
							causas[0].fatores_paciente,
						),
						fator_profissional: normalizeEmptyValue(
							causas[0].fatores_profissionais,
						),
						fator_tarefa: normalizeEmptyValue(
							causas[0].fatores_tarefa,
						),
						fator_comunicacao: normalizeEmptyValue(
							causas[0].fatores_comunicacao,
						),
						fator_equipamento: normalizeEmptyValue(
							causas[0].fatores_equipamento,
						),
						fator_ambiente: normalizeEmptyValue(
							causas[0].fatores_ambiente,
						),
						fator_organizacional: normalizeEmptyValue(
							causas[0].fatores_organizacionais,
						),
						fator_treinamento: normalizeEmptyValue(
							causas[0].fatores_treinamento,
						),
					},
				}));
			}
		}

		setNoteId(result.id);
		setClassForm({
			classificacao: result.classificacao,
			prazo_investigacao: result.prazo_investigacao,
			sub_classificacao: result.sub_classificacao,
			notificacao: result.protocolo,
		});
	};

	useEffect(() => {
		handleNeverEvents();
		const handleEsc = (e) => {
			if (e.key === 'Escape') setEmailAlert(false);
		};
		window.addEventListener('keydown', handleEsc);
		return () => window.removeEventListener('keydown', handleEsc);
	}, []);

	useEffect(() => {
		if (notificacao) {
			if (notificacao.status === 'NOTIFICADO') {
				setForm({
					...form,
					notificacao: notificacao.protocolo,
					unidade_token_notificacao: notificacao.token_notificacao,
					fato_presenciado: notificacao.fato_presenciado,
					quem_presenciou: notificacao.quem_presenciou,
					envolve_paciente: notificacao.envolve_paciente,
					sexo_paciente: notificacao.sexo_paciente,
					nome_paciente: notificacao.nome_paciente,
					nascimento_paciente: notificacao.nascimento_paciente,
					prontuario: notificacao.prontuario,
				});
				if (cards.caso !== cards.card) {
					return setIsButtonEnabled(false);
				}
			}
			if (notificacao.status === 'CLASSIFICADO') {
				perRequest();
				if (cards.caso !== cards.card) {
					return setIsButtonEnabled(false);
				}
			}
			if (notificacao.status === 'INVESTIGADO') {
				/* listInv();
				setInvForm({
					...invForm,
					notificacao: notificacao.protocolo,
				}); */
				perRequest();
				if (cards.caso !== cards.card) {
					return sendButtonEnabled(notificacao);
				} else {
					return sendButtonEnabled(notificacao);
				}
			}
			if (notificacao?.status === 'CONCLUIDO') {
				isRejected();
				if (notificacao?.classificacao?.descartar === true) {
					setForm({
						...form,
						notificacao: notificacao.protocolo,
					});
					setIsButtonEnabled(false);
				} else {
					/* listInv(); */
					listAval(invId);

					perRequest();

					const prev = finalForm;

					setFinalForm({
						...prev,
						notificacao: notificacao.protocolo,
					});

					if (
						cards.caso === 'INVESTIGADO' &&
						cards.card === 'INVESTIGADO' &&
						notificacao.status === 'CONCLUIDO'
					) {
						return setIsButtonEnabled(false);
					} else if (cards.caso !== cards.card) {
						return setIsButtonEnabled(false);
					}
				}
			}
			setForm((prevForm) => ({
				...prevForm,
				num_notificacao: notificacao.protocolo,
				data_notificacao: notificacao.data_notificacao,
				data_ocorrencia: notificacao.data_ocorrencia,
				unidade: notificacao.unidade,
				setor:
					form?.setor?.length > 0 ? form?.setor : notificacao.setor,
				nome_paciente: notificacao.nome_paciente,
				sexo_paciente: notificacao.sexo_paciente,
				nascimento_paciente: notificacao.nascimento_paciente,
				prontuario: notificacao.prontuario,
				notificador: notificacao.notificante,
				notificador_setor: notificacao.notificante_setor,
				notificador_cargo: notificacao.notificante_cargo,
				tipo_incidente: notificacao.tipo_incidente,
				quem_presenciou: notificacao.quem_presenciou,
				descricao_ocorrencia: notificacao.descricao,
				acoes_imediatas: notificacao.acoes_imediatas,
				medida_preventiva: notificacao.medida_preventiva,
				fato_presenciado: notificacao.fato_presenciado,
				turno: notificacao.turno,
				other_checked:
					notificacao.tipo_incidente_outros !== '' ? true : false,
			}));
		}
	}, []);
	/* useEffect(() => {
	
	}, [invForm]); */

	return (
		<div className='flex flex-col min-h-screen items-center justify-center'>
			{enviado ? (
				<div className='font-inter flex justify-center items-start w-[80%] mx-auto h-screen'>
					<div className='flex flex-col bg-[#F5F5F5] mt-[100px]  items-center rounded-md  max-w-[800px] gap-5 flex-grow shadow-lg'>
						<div className='bg-[#004A80] rounded-t-md w-full h-[20px] '>
							{' '}
						</div>
						<div className='text-[#00C0F3]   '>
							<IoMdCheckmarkCircle className='size-[50px] sm:size-[100px]' />
						</div>
						<div className='sm:text-3xl font-semibold text-[#004A80]'>
							{' '}
							{notificacao?.status === 'NOTIFICADO' &&
								'Classificação feita com Sucesso'}
							{notificacao?.status === 'CLASSIFICADO' &&
								'Investigação feita com Sucesso'}
							{notificacao?.status === 'INVESTIGADO' &&
								'Notificação concluída com Sucesso'}
						</div>

						<div className='text-sm flex justify-center  text-center sm:text-lg font-medium mx-auto w-[80%] text-[#8b8b8b]'>
							{' '}
							{`A etapa foi concluída com sucesso,
							acompanhe o andamento dela através do painel de
							acompanhamento ou consultando o protocolo abaixo.`}{' '}
						</div>
						<div className='flex flex-col sm:text-4xl font-bold mt-2 sm:mt-[32px] text-[#004A80]'>
							<div className='flex gap-3'>
								<div>Protocolo: </div>
								<button
									onClick={handleCopy}
									value={notificacao?.protocolo}
									className='appearence-none'>
									{notificacao?.protocolo}
									{/* {' '}
									{Math.floor(Math.random() * 1000000)} */}
								</button>
							</div>

							{copiado ? (
								<div className='flex flex-col justify-end '>
									<div className='text-[#a0a0a0] font-semibold text-end  text-[12px]'>
										Protocolo copiado!
									</div>
								</div>
							) : null}
						</div>
						<p className='text-xs sm:text-lg mx-auto text-center sm:text-start text-[#a0a0a0] mt-4  '>
							Clique no botão abaixo para baixar o PDF da sua
							notificação
						</p>
						<button
							className='sm:w-35 flex items-center justify-center gap-2 border border-[#B74644] text-[#B74644] p-1 sm:py-2 sm:px-4 rounded-md hover:bg-[#B74644] hover:text-white transition-all duration-200 text-[10px] sm:text-base focus:outline-none cursor-pointer sm:mb-[40px]'
							onClick={() => {
								handleDownloadPDF();
								setPdfBaixado(true);
							}}>
							{pdfBaixado ? (
								'Download Concluído'
							) : (
								<>
									<FaRegFilePdf className='scale-[130%] text-[10px]' />
									Baixar PDF
								</>
							)}
						</button>

						<a
							className='text-[#00C0F3] text-[10px] sm:text-base mb-14 hover:text-[#004A80] transition-all duration-200'
							href='/hub-de-notificacoes'>
							{' '}
							voltar à consulta de protocolos
						</a>
					</div>
				</div>
			) : (
				<div
					className={`${
						formLayout ? 'px-1 w-full' : 'px-1 max-w-[100vw]'
					}`}>
					<div
						ref={formRef}
						id='my-table-id'
						className={`${
							formLayout
								? 'mx-auto  w-full max-w-[1130px] mt-10 lg:px-8 overflow-hidden'
								: 'sm:mx-auto sm:w-full w-full max-w-[100vw] sm:max-w-[1130px] sm:mt-10 sm:px-6 lg:px-8 overflow-hidden'
						}`}>
						<div id='block1'>
							<div
								className={`${
									formLayout
										? 'flex flex-row justify-between w-full h-[150px] my-1 mt-[-50px]'
										: 'flex flex-col md:flex-row justify-between w-full h-[150px] my-1'
								}`}>
								<div
									className={`${
										formLayout
											? 'w-[40%] h-[105px] my-3 flex justify-start'
											: 'w-0 md:w-[30%] h-[105px] my-3 flex justify-center md:justify-start'
									}`}>
									<img
										alt='logo da prefeitura'
										src={Logo}
										className={`${
											formLayout
												? 'h-[80%] mt-6 scale-75 object-contain'
												: 'h-full scale-75 object-contain sm:block hidden'
										}`}
									/>
								</div>
								<div
									id='id_setor_edit'
									className={`${
										formLayout
											? 'w-[65%] h-[105px] my-5 text-white font-bold text-center flex items-center justify-center'
											: 'w-full md:w-[65%] h-[105px] my-5 text-white font-bold text-center flex items-center justify-center'
									}`}>
									<p
										className={`${
											formLayout
												? 'p-0 pb-10 text-3xl bg-gray-800 h-full content-center'
												: 'sm:text-2xl py-5 px-5 md:p-0 lg:text-3xl bg-gray-800 h-full content-center'
										}`}>
										ANÁLISE E TRATAMENTO DE EVENTOS ADVERSOS
									</p>
								</div>
							</div>
							<div className='w-full border-[1px] border-black'>
								<div className='w-full'>
									<div
										className={`${
											formLayout
												? 'flex flex-row'
												: 'flex flex-col md:flex-row'
										}`}>
										<div
											className={`${
												formLayout
													? 'flex w-full justify-start md:w-1/2 border-r-[1px] border-b-[1px] border-black px-2 py-3'
													: 'flex w-full justify-start md:w-1/2 sm:border-r-[1px] border-b-[1px] border-black px-2 py-3'
											}`}>
											<p className='font-semibold w-4/12 mr-2 text-start content-center '>
												Notificação n.º:{' '}
											</p>
											{notificacao?.protocolo}
										</div>
										<div
											className={`${
												formLayout
													? 'flex w-full justify-start md:w-1/2 border-r-[1px] border-b-[1px] border-black px-2 py-3'
													: 'flex w-full justify-start md:w-1/2 sm:border-r-[1px] border-b-[1px] border-black px-2 py-3'
											}`}>
											<p className='font-semibold w-6/12 text-start content-center mr-2 '>
												Data da notificação:
											</p>

											{notificacao?.data_notificacao
												? formatDate(
														notificacao?.data_notificacao,
													)
												: '00/00/0000'}
										</div>
										<div
											className={`${
												formLayout
													? 'flex w-full justify-start md:w-1/2  border-b-[1px] border-black px-2 py-3'
													: 'flex w-full justify-start md:w-1/2  sm:border-r-[0px] border-b-[1px] border-black px-2 py-3'
											}`}>
											<p className='font-semibold w-6/12 text-start content-center mr-2'>
												Data da ocorrência:
											</p>

											{formatDate(
												notificacao?.data_ocorrencia
													? notificacao?.data_ocorrencia
													: '00/00/0000',
											)}
										</div>
									</div>
									<div
										className={`${
											formLayout
												? 'flex flex-row'
												: 'flex flex-col md:flex-row'
										}`}>
										<div
											className={`${
												formLayout
													? 'flex w-full justify-start md:w-1/2 border-r-[1px] border-b-[1px] border-black px-2 py-3'
													: 'flex w-full justify-start md:w-1/2 sm:border-r-[1px] border-b-[1px] border-black px-2 py-3'
											}`}>
											<p className='font-semibold content-center align-baseline py-1 mr-2'>
												Unidade:
											</p>
											<p className='mx-4 content-center'>
												{notificacao?.unidade_nome}
											</p>
										</div>

										{editSetor ? (
											<div
												className={`${
													formLayout
														? 'flex w-8/12 border-b-[1px] border-r-[1px] border-black px-2 py-3'
														: 'relative flex w-full md:w-7/12 border-b-[1px] border-black px-2 py-3  sm:border-r-[1px]'
												}`}>
												<p className='font-semibold content-center w-6/12 py-1'>
													Setor onde ocorreu o
													incidente:
												</p>
												<div className='flex-1'>
													{formLayout ? (
														<div className='content-center text-gray-700'>
															{
																editedSetorForm?.setor_ocorrencia
															}
														</div>
													) : (
														<div className='flex flex-start relative animate-fadeIn'>
															<input
																type='text'
																name='setor'
																id='setor'
																autoComplete='new-field'
																autoCorrect='off'
																autoCapitalize='none'
																spellCheck='false'
																value={search}
																onChange={(
																	e,
																) => {
																	const val =
																		e.target
																			.value;

																	setSearch(
																		val,
																	);
																	setOpen(
																		true,
																	);
																	// Sempre que digitar ou apagar algo, limpa o estado real
																	setEditedSetorForm(
																		(
																			prevFormData,
																		) => {
																			return {
																				...prevFormData,
																				setor_ocorrencia:
																					'',
																			};
																		},
																	);
																	setSetorEdited(
																		false,
																	);
																	handleForm(
																		'',
																		'setor',
																	);
																}}
																onFocus={() =>
																	setOpen(
																		true,
																	)
																}
																onBlur={() =>
																	setTimeout(
																		() => {
																			setOpen(
																				false,
																			);
																		},
																		150,
																	)
																}
																placeholder='Selecione ou digite...'
																className={`w-full h-9 border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white text-gray-700
						${setorEdited === false ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'}
					`}
															/>
															{/* Dropdown */}
															{open &&
																(unitSectors.length >
																0
																	? unitSectors
																	: setoresAlbert
																).filter(
																	(set) => {
																		const optionText =
																			(
																				set.nome
																					? set.nome
																					: set
																			)
																				.normalize(
																					'NFD',
																				)
																				.replace(
																					/[\u0300-\u036f]/g,
																					'',
																				)
																				.toLowerCase();

																		const searchText =
																			(
																				search ||
																				''
																			)
																				.normalize(
																					'NFD',
																				)
																				.replace(
																					/[\u0300-\u036f]/g,
																					'',
																				)
																				.toLowerCase();

																		return optionText.includes(
																			searchText,
																		);
																	},
																).length >
																	0 && (
																	<ul className='absolute z-10 w-full bg-white border border-gray-300 rounded-md top-10 max-h-48 overflow-y-auto text-start shadow-lg'>
																		{(unitSectors?.length >
																		0
																			? unitSectors
																			: setoresAlbert
																		)
																			.filter(
																				(
																					set,
																				) => {
																					const optionText =
																						(
																							set.nome
																								? set.nome
																								: set
																						)
																							.normalize(
																								'NFD',
																							)
																							.replace(
																								/[\u0300-\u036f]/g,
																								'',
																							)
																							.toLowerCase();

																					const searchText =
																						(
																							search ||
																							''
																						)
																							.normalize(
																								'NFD',
																							)
																							.replace(
																								/[\u0300-\u036f]/g,
																								'',
																							)
																							.toLowerCase();

																					return optionText.includes(
																						searchText,
																					);
																				},
																			)
																			.map(
																				(
																					set,
																					i,
																				) => (
																					<li
																						key={
																							set.nome
																								? `${set.nome}-${i}`
																								: `${set}-${i}`
																						}
																						onMouseDown={() => {
																							const val =
																								set.nome
																									? set.nome
																									: set;

																							// Preenche estado real
																							setEditedSetorForm(
																								(
																									prevFormData,
																								) => {
																									return {
																										...prevFormData,
																										setor_ocorrencia:
																											val,
																									};
																								},
																							);
																							setSetorEdited(
																								true,
																							);
																							handleForm(
																								val,
																								'setor',
																							);

																							// Mostra valor selecionado no input
																							setSearch(
																								val,
																							);

																							setOpen(
																								false,
																							);
																						}}
																						className='px-3 py-2 cursor-pointer hover:bg-blue-100 transition-colors duration-150'>
																						{set.nome
																							? set.nome
																							: set}
																					</li>
																				),
																			)}
																	</ul>
																)}
														</div>
													)}
												</div>
												<div className='h-full flex content-center items-center ml-2'>
													<button
														onClick={() => {
															setEditSetor(false);
															handleEditSetor();
														}}
														title='Confirmar edição'
														className='bg-[#32993E] hover:bg-[#21752a] text-white px-1.5  rounded-md shadow-sm transition-all duration-200 ease-in-out   font-bold text-lg'>
														✓
													</button>
												</div>
											</div>
										) : (
											<div
												className={`${
													formLayout
														? 'flex w-8/12 border-b-[1px] border-r-[1px] border-black px-2 py-3'
														: 'relative flex w-full md:w-7/12 border-b-[1px] border-black px-2 py-3  sm:border-r-[1px]'
												}`}>
												<p className='font-semibold content-center w-6/12 py-1'>
													Setor onde ocorreu o
													incidente:
												</p>
												<p
													className={`mx-2 content-center transition-colors duration-300 ${
														setorEdited === false
															? 'text-red-500 font-medium'
															: 'text-gray-700'
													}`}>
													{editedSetorForm
														?.setor_ocorrencia
														?.length > 0
														? editedSetorForm?.setor_ocorrencia
														: notificacao?.setor}
												</p>

												{formLayout
													? null
													: cards.caso ===
															'NOTIFICADO' && (
															<button
																value={false}
																id={
																	'setor_adequado'
																}
																onClick={() => {
																	handleSectors();
																	setEditedSetorForm(
																		(
																			prevFormData,
																		) => {
																			return {
																				...prevFormData,
																				setor_adequado: false,
																			};
																		},
																	);
																	setSetorEdited(
																		false,
																	);
																	setEditSetor(
																		true,
																	);
																	setSearch(
																		'',
																	);
																}}
																title='Editar setor'
																className='absolute right-3 top-1/2 -translate-y-1/2  bg-[#204c81] hover:bg-[#13335A] text-white p-2 rounded-md shadow-sm transition-all duration-200 ease-in-out  opacity-70 hover:opacity-100'>
																<FiEdit className='h-4 w-4' />
															</button>
														)}
											</div>
										)}

										<style jsx>{`
											@keyframes fadeIn {
												from {
													opacity: 0;
													transform: translateY(-5px);
												}
												to {
													opacity: 1;
													transform: translateY(0);
												}
											}
											.animate-fadeIn {
												animation: fadeIn 0.3s
													ease-in-out;
											}
										`}</style>
										<div className='flex border-b-[1px] items-center border-black px-2 py-3'>
											<p className='font-semibold  text-start py-1'>
												Turno:
											</p>
											<p className='mx-4 content-center'>
												{notificacao?.turno_display}
											</p>
										</div>
									</div>
									<div className='flex border-b-[1px] border-black px-2 py-3'>
										<p className='font-semibold  text-start py-1'>
											{form?.envolve_paciente === false ||
											form?.nome_paciente === '' ||
											!form?.nome_paciente
												? 'Incidente envolve paciente?  '
												: 'Nome Completo do Paciente:'}
										</p>

										<p className='mx-4 content-center'>
											{form?.envolve_paciente === false ||
											form?.nome_paciente === '' ||
											!form?.nome_paciente
												? 'Não'
												: form?.nome_paciente}
										</p>
									</div>
									<div
										className={`${
											formLayout
												? 'w-full flex flex-row relative'
												: 'w-full flex flex-col md:flex-row relative'
										}`}>
										{!notificacao.envolve_paciente && (
											<div className='absolute bg-white opacity-[60%] h-full w-full'></div>
										)}
										<div
											className={`${
												formLayout
													? 'flex xs:w-1/4 border-r-[1px] border-b-[1px] border-black px-2 py-3'
													: 'flex xs:w-1/4 sm:border-r-[1px] border-b-[1px] border-black px-2 py-3 '
											}`}>
											<p className='font-semibold text-start mr-3 content-center'>
												Sexo:
											</p>
											<div className='flex  gap-4 '>
												<label className='flex items-end py-1 '>
													<input
														type='radio'
														name='sexo_paciente'
														id='masculino'
														checked={
															form?.envolve_paciente
																? form?.sexo_paciente ===
																	'M'
																: false
														}
														{...(form?.status ===
															'NOTIFICADO' &&
															'readOnly')}
														className=' h-4 w-4 text-blue-600'
													/>
													<span className='ml-2 text-sm'>
														Masculino
													</span>
												</label>
												<label className='flex items-end py-1'>
													<input
														type='radio'
														name='sexo_paciente'
														id='feminino'
														checked={
															form?.envolve_paciente
																? form?.sexo_paciente ===
																	'F'
																: false
														}
														{...(form?.status ===
															'NOTIFICADO' &&
															'readOnly')}
														className=' h-4 w-4 text-blue-600'
													/>
													<span className='ml-2 text-sm'>
														Feminino
													</span>
												</label>
											</div>
										</div>
										<div
											className={`${
												formLayout
													? 'flex w-full justify-start md:w-5/12  border-b-[1px] border-black  px-2 py-3'
													: 'flex w-full justify-start md:w-5/12  border-b-[1px] border-black px-2 py-3'
											}`}>
											<p className='font-semibold w-7/12 text-start content-center'>
												Data de Nascimento:
											</p>
											<p className='content-center'>
												{' '}
												{form?.envolve_paciente
													? form?.nascimento_paciente ===
														''
														? formatDate(
																form?.nascimento_paciente
																	? form?.nascimento_paciente
																	: '00/00/0000',
															)
														: formatDate(
																form?.nascimento_paciente
																	? form?.nascimento_paciente
																	: '00/00/0000',
															)
													: ''}
											</p>
										</div>
										<div className='flex w-full md:w-2/3 sm:border-l border-b-[1px] border-black px-2 py-3'>
											<p className='font-semibold content-center py-1'>
												Prontuário/BE:
											</p>
											<p className='mx-4 content-center flex flex-grow w-[80%]'>
												{form?.envolve_paciente &&
													form?.prontuario}
											</p>
											{/* <input
												name='prontuario'
												id='prontuario'
												onChange={({
													target: { value, id },
												}) => handleForm(value, id)}
												className=' ml-2 w-full focus:outline-none'
												type='text'
											/> */}
										</div>
									</div>

									{cards.caso !== 'CLASSIFICADO' &&
										formLayout === false && (
											<div
												className={` ${
													formLayout
														? 'flex'
														: 'sm:flex'
												}   ${'w-full md:w-full border-black  gap-1 '}`}>
												<div
													className={`w-full sm:w-[70%] flex flex-col justify-start items-start pl-3  gap-1  ${
														formLayout
															? ' pb-1 border-t-[0px] '
															: ' py-3 border-t-[1px] sm:border-t-[0px]'
													} border-black`}>
													<p
														className={`${'font-semibold  content-center text-start py-1 sm:w-auto text-[14px]  '}`}>
														Identificação do
														profissional (Opcional)
													</p>

													<div className='w-full flex justify-start items-center h-8  px-2 py-1 focus:outline-none transition duration-200 border-gray-400 bg-white'>
														{notificacao?.notificante ===
															'' ||
														notificacao?.notificante ===
															null
															? 'Não consta'
															: notificacao?.notificante}
													</div>
												</div>
												<div
													className={`w-full sm:w-[70%] flex flex-col justify-start items-start pl-3  gap-1  ${
														formLayout
															? 'pb-1 border-l-[1px] border-t-[0px] '
															: 'sm:border-l-[1px] py-3 border-t-[1px] sm:border-t-[0px]'
													} border-black`}>
													<p
														className={`${'font-semibold  content-center text-start py-1 sm:w-auto text-[14px]  '}`}>
														Setor notificador
														(obrigatório):
													</p>

													<div className='w-full flex justify-start items-center h-8  px-2 py-1 focus:outline-none transition duration-200 border-gray-400 bg-white'>
														{notificacao?.notificante_setor ===
															'' ||
														notificacao?.notificante_setor ===
															null
															? 'Não consta'
															: notificacao?.notificante_setor}
													</div>
												</div>
												<div
													className={`w-full sm:w-[70%] flex flex-col justify-start items-start pl-3  gap-1  ${
														formLayout
															? ' pb-1 border-l-[1px] border-t-[0px] '
															: 'sm:border-l-[1px] py-3 border-t-[1px] sm:border-t-[0px]'
													} border-black`}>
													<p
														className={`${'font-semibold  content-center text-start py-1 sm:w-auto text-[14px]'}`}>
														Cargo do notificador
														(opcional):
													</p>

													<div className='w-[90%] h-8  px-2 py-1 focus:outline-none transition duration-200 border-gray-400 bg-white'>
														{notificacao?.notificante_cargo ===
															'' ||
														notificacao?.notificante_cargo ===
															null
															? 'Não consta'
															: notificacao?.notificante_cargo}
													</div>
												</div>
											</div>
										)}
								</div>
							</div>

							<div className='w-full my-5 border-[1px] border-black'>
								<div className='w-full bg-gray-300 py-2 text-center font-bold'>
									INCIDENTES E NÃO CONFORMIDADES
								</div>
								<div className='w-full border-b-[1px] border-t border-black p-4'>
									<div
										className={`${
											formLayout
												? 'grid grid-cols-2 gap-4'
												: 'grid grid-cols-1 lg:grid-cols-2 gap-4'
										}`}>
										{tiposIncidentes.map(
											(incident, index) => (
												<label
													key={index + 'b'}
													className='flex items-center sm:whitespace-nowrap'>
													<input
														type='radio'
														name='tipo_incidente'
														checked={
															incident.value ===
															notificacao?.tipo_incidente
														}
														value={incident.display}
														id={incident.display}
														className='form-radio h-3 w-3 md:h-4 md:w-4 text-blue-600'
													/>
													<span
														className={`${
															formLayout
																? 'ml-2 text-gray-700 mb-2 text-base'
																: 'ml-2 text-gray-700 text-sm md:text-base '
														}`}>
														{incident.display}
													</span>
												</label>
											),
										)}
										<label className='flex items-center whitespace-nowrap'>
											<input
												type='radio'
												name='tipo_incidente'
												checked={
													notificacao?.tipo_incidente ===
													'OUTROS'
												}
												className='form-radio h-3 w-3 md:h-4 md:w-4 text-blue-600'
											/>

											<span className='ml-2 text-gray-700 flex items-center w-10/12 text-sm md:text-base'>
												Outro:
												{notificacao
													?.tipo_incidente_outros
													?.length > 0 ? (
													<div
														type='text'
														name='tipo_incidente'
														className={`ml-2 h-auto text-xs md:text-sm border-b-[1px] border-gray-500 focus:outline-none
		${
			formLayout
				? 'whitespace-normal break-words max-w-full overflow-visible h-auto pb-2'
				: 'whitespace-nowrap overflow-x-auto max-w-[350px] sm:max-w-full'
		}
		scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-transparent`}>
														{
															notificacao?.tipo_incidente_outros
														}
													</div>
												) : null}
											</span>
										</label>
									</div>
								</div>
								<div
									className={`flex w-full  ${
										formLayout
											? 'flex-row py-4'
											: 'flex-col sm:flex-row py-2'
									}`}>
									<p
										className={`font-semibold px-2 content-center text-start ${
											formLayout
												? 'w-full sm:w-5/12 text-sm sm:text-base'
												: 'w-full sm:md:w-5/12 text-[12px] mb-2 sm:mb-0 sm:text-xs md:text-sm'
										}`}>
										O fato foi presenciado por alguém?
									</p>

									<div className='w-full flex flex-row items-center px-2 gap-3 sm:gap-4'>
										<label className='flex items-center text-xs sm:text-sm'>
											<input
												type='radio'
												name='quem_presenciou'
												id='ninguem'
												checked={
													!notificacao?.quem_presenciou &&
													!form?.quem_presenciou
												}
												className='form-radio h-3 w-3 sm:h-4 sm:w-4 text-blue-600'
											/>
											<span
												className={`ml-2 text-gray-700 ${
													formLayout ? 'mb-1' : ''
												} text-xs sm:text-sm`}>
												Não
											</span>
										</label>
										<label className='flex items-center w-full font-semibold text-xs sm:text-sm'>
											<input
												type='radio'
												name='quem_presenciou'
												id='sim'
												checked={
													!!notificacao?.quem_presenciou ||
													!!form?.quem_presenciou
												}
												className='form-radio h-3 w-3 sm:h-4 sm:w-4 text-blue-600'
											/>
											<span className='ml-2 text-gray-700 flex w-full items-center'>
												<span
													className={`text-gray-700 text-xs sm:text-sm ${
														formLayout
															? 'w-4/12 text-start py-1'
															: 'md:w-3/12 text-start py-1'
													}`}>
													Sim?
												</span>
												{notificacao?.quem_presenciou ||
												form?.quem_presenciou ? (
													<p
														id='quem_presenciou'
														className={`w-full h-[20px] text-xs sm:text-sm ${
															formLayout
																? ''
																: 'border-b-[1px] ml-3 sm:ml-0 border-gray-500'
														} focus:outline-none`}>
														{notificacao?.quem_presenciou ||
															form?.quem_presenciou}
													</p>
												) : null}
											</span>
										</label>
									</div>
								</div>
							</div>
							<div className='pdf-section no-break  w-full my-5 border-[1px] border-black'>
								<div className='text-start px-2 font-semibold'>
									Descrição da ocorrência.
								</div>
								<div
									name='descricao_ocorrencia'
									id='descricao_ocorrencia'
									className={`w-full mt-2 px-2 text-sm text-gray-700 border-none focus:outline-none focus:ring-0 resize-none break-words whitespace-pre-wrap ${
										formLayout ? 'min-h-20 py-2' : 'h-auto'
									}`}>
									{notificacao?.descricao}
								</div>
							</div>

							<div className='pdf-section no-break  w-full my-5 border-[1px] border-black'>
								<div className='text-start px-2 font-semibold'>
									Ações imediatas tomadas.
								</div>
								<div
									name='acoes_imediatas'
									id='acoes_imediatas'
									className={`w-full mt-2 px-2 text-sm text-gray-700 border-none focus:outline-none focus:ring-0 resize-none break-words whitespace-pre-wrap ${
										formLayout ? 'min-h-20 py-2' : 'h-auto'
									}`}>
									{notificacao?.acoes_imediatas}
								</div>
							</div>

							<div className='pdf-section no-break  w-full  my-5 border-[1px] border-black'>
								<div className='text-start px-2 font-semibold'>
									Existe alguma medida em vigor para prevenir
									tal incidente? Qual?
								</div>

								<div
									name='medida_preventiva'
									id='medida_preventiva'
									className={`w-full mt-2 px-2 text-sm text-gray-700 border-none focus:outline-none focus:ring-0 resize-none break-words whitespace-pre-wrap ${
										formLayout ? 'min-h-20 py-2' : 'h-auto'
									}`}>
									{notificacao?.medida_preventiva}
								</div>
							</div>
						</div>

						<div id='block2'>
							{((notificacao?.status === 'NOTIFICADO' &&
								cards.card === cards.caso) ||
								notificacao?.status === 'CLASSIFICADO' ||
								notificacao?.status === 'INVESTIGADO' ||
								notificacao?.status === 'CONCLUIDO') &&
							notificacao?.classificacao?.descartar !== true &&
							concluido === false ? (
								<div
									className={`${
										formLayout
											? 'w-full my-5 border-[1px] mb-10  border-black'
											: 'w-full my-5 border-[1px]  border-black'
									}`}>
									<div
										className={`${
											formLayout
												? 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold pb-4'
												: 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold'
										}`}>
										CLASSIFICAÇÃO INCIDENTE
									</div>
									<div className='w-full p-2'>
										<div className='flex flex-col gap-2 mt-2'>
											{classificacoes.map(
												(evento, index) => (
													<div
														key={
															evento.display +
															'c' +
															index
														}
														className={`flex items-start gap-2`}>
														<input
															type='radio'
															name='opcao'
															id='classificacao'
															checked={
																notificacao?.status ===
																'NOTIFICADO'
																	? undefined
																	: classForm.classificacao ===
																		evento.display
															}
															value={
																evento.display
															}
															className={`${
																formLayout
																	? 'mt-[10px]'
																	: 'mt-[4px]'
															}`}
															onChange={
																notificacao?.status ===
																'NOTIFICADO'
																	? handleClassForm
																	: null
															}
														/>
														<label
															htmlFor={
																evento.display
															}
															className={`${
																formLayout
																	? 'flex gap-2 mb-2'
																	: 'flex gap-2'
															}`}>
															<p className='text-sm font-normal content-center'>
																<span className='font-bold'>
																	{
																		evento.value
																	}
																	:
																</span>{' '}
																{
																	evento.descricao
																}
															</p>
														</label>
													</div>
												),
											)}
											<div className='flex items-start gap-2'>
												<input
													type='radio'
													name='opcao'
													id='classificacao'
													onChange={handleClassForm}
													disabled={
														notificacao?.status ===
														'NOTIFICADO'
															? false
															: classForm.classificacao ===
																  'NEVER_EVENTS'
																? false
																: true
													}
													checked={
														notificacao?.status ===
														'NOTIFICADO'
															? undefined
															: classForm.classificacao ===
																'NEVER_EVENTS'
													}
													value='NEVER_EVENTS'
													className='mt-[4px]'
												/>
												<label
													htmlFor='never'
													className={`${
														formLayout
															? 'flex gap-2'
															: 'flex gap-2'
													}`}>
													<div className='text-sm font-normal content-center flex gap-2'>
														<span className='font-bold'>
															Never Events:
														</span>{' '}
														{notificacao?.status ===
														'NOTIFICADO' ? (
															<div>
																{formLayout ? (
																	<div>
																		{classForm.sub_classificacao ===
																		''
																			? 'Nenhum Never Event'
																			: neverList.find(
																					(
																						event,
																						index,
																					) =>
																						event.id ===
																						parseInt(
																							classForm?.sub_classificacao,
																						),
																				)
																					?.nome}
																	</div>
																) : (
																	<select
																		className='w-[290px] bg-[#f0f0f0] p-1 rounded-md'
																		value={
																			notificacao
																				?.classificacao
																				?.classificacao ===
																			'NEVER_EVENTS'
																				? notificacao
																						?.classificacao
																						?.sub_classificacao
																				: classForm.sub_classificacao
																		}
																		id='sub_classificacao'
																		onChange={
																			handleClassForm
																		}>
																		<option
																			value=''
																			className=''>
																			Escolha
																			um
																			valor
																			de
																			acordo
																			com
																			o
																			evento
																		</option>
																		{neverList.map(
																			(
																				item,
																				index,
																			) => (
																				<option
																					key={
																						index +
																						'g'
																					}
																					id='sub_classificacao'
																					value={
																						item.id
																					}
																					className='flex mb-10'>
																					{
																						item?.label
																					}
																				</option>
																			),
																		)}
																	</select>
																)}{' '}
															</div>
														) : (
															<p className=''>
																{classForm?.sub_classificacao ===
																''
																	? 'Nenhum Never Event'
																	: neverList.find(
																			(
																				event,
																				index,
																			) =>
																				event.id ===
																				parseInt(
																					classForm?.sub_classificacao,
																				),
																		)?.nome}
															</p>
														)}
													</div>
												</label>
											</div>
										</div>
									</div>
								</div>
							) : null}
							{((notificacao?.status === 'NOTIFICADO' &&
								cards.card === cards.caso) ||
								notificacao?.status === 'CLASSIFICADO' ||
								notificacao?.status === 'INVESTIGADO' ||
								notificacao?.status === 'CONCLUIDO') &&
							notificacao?.classificacao?.descartar !== true &&
							concluido === false ? (
								<div
									className={`${
										formLayout
											? 'w-full my-5 mt-10 border-[1px]  border-black'
											: 'w-full my-5 border-[1px]  border-black'
									}`}>
									<div
										className={`${
											formLayout
												? 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold '
												: 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold'
										}`}>
										ANÁLISE DO INCIDENTE
										<p
											className={`${
												formLayout ? 'mb-4' : ''
											}`}>
											{
												'(preenchimento pelo Núcleo de Segurança do Paciente)'
											}
										</p>
									</div>

									<div
										className={`${
											formLayout
												? 'w-full p-2 flex gap-6 mb-2'
												: 'w-full p-2 flex gap-6'
										}`}>
										<p className='text-[12px] sm:text-[16px]'>
											Prazo máximo para que ocorra a
											investigação:{' '}
										</p>
										{notificacao.status !== 'NOTIFICADO' ? (
											<div>
												{classForm.prazo_investigacao
													? formatDate(
															classForm.prazo_investigacao,
														)
													: '00/00/0000'}
											</div>
										) : (
											<div className='flex gap-5'>
												{classForm.classificacao ===
													'GRAVE' ||
												classForm.classificacao ===
													'OBITO' ||
												(classForm.classificacao ===
													'NEVER_EVENTS' &&
													classForm.sub_classificacao
														.length > 0) ? (
													<p>
														{
															classForm.prazo_investigacao
														}
													</p>
												) : (
													<input
														type='date'
														id='prazo_investigacao'
														value={
															classForm.prazo_investigacao
														}
														className='sm:h-auto h-8'
														onChange={
															handleClassForm
														}
													/>
												)}

												{validDate ? (
													<p className='text-red-600 font-medium  font-inter text-[10px]  sm:text-[12px] content-center'>
														data inválida (a data
														deve ser posterior a
														data atual)
													</p>
												) : null}
											</div>
										)}
									</div>
								</div>
							) : null}
							{((notificacao?.status === 'CLASSIFICADO' &&
								cards.card === cards.caso) ||
								notificacao?.status === 'INVESTIGADO' ||
								notificacao?.status === 'CONCLUIDO') &&
							concluido === false ? (
								<div className='w-full my-5 border-[1px] mb-10 border-black'>
									<div
										className={`${
											formLayout
												? 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold pb-4'
												: 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold'
										}`}>
										EQUIPE DE INVESTIGAÇÃO
										{/* 	<input
										type='text'
										id='exampleInput'
										name='example'
										defaultValue='Texto inicial'
										className='w-full text-base leading-8'
									/> */}
									</div>
									<div className='grid'>
										<div className='h-[30px] w-full flex'>
											<div
												className={`${
													formLayout
														? 'w-full content-center h-[full] font-semibold border-[1px] border-r-black  text-center pb-4'
														: 'w-full content-center h-[full] font-semibold border-[1px] border-r-black  text-center sm:text-base text-[10px]'
												}`}>
												NOME COMPLETO
											</div>
											<div
												className={`${
													formLayout
														? 'w-full content-center h-[full] font-semibold border-[1px] border-r-black  text-center pb-4'
														: 'w-full content-center h-[full] font-semibold border-[1px] sm:text-base text-[10px] border-r-black  text-center '
												}`}>
												CARGO
											</div>
											<div
												className={`${
													formLayout
														? 'w-full content-center h-[full] font-semibold border-[1px] border-r-black  text-center pb-4'
														: 'w-full content-center h-[full] font-semibold border-[1px] sm:text-base text-[10px] border-r-black  text-center '
												}`}>
												SETOR
											</div>
											<div
												className={`${
													formLayout
														? 'w-full h-[full] border-[1px]  font-semibold content-center text-center pb-4 '
														: 'w-full h-[full] border-[1px]  font-semibold content-center text-center sm:text-base text-[10px] '
												}`}>
												E-MAIL
											</div>
										</div>
									</div>

									{Array.from('x'.repeat(counter)).map(
										(item, index) => (
											<div
												key={index + 'per'}
												id={index + 'cron'}
												className='flex'>
												<div className='flex w-full'>
													<div
														className={`w-[30%] border-[1px] border-black border-t-[2px] px-2 py-1 ${
															formLayout === true
																? `break-all pb-2`
																: `overflow-auto`
														}`}>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ||
														formLayout === true ||
														autorized === false ? (
															<div className='px-2 w-full text-center'>
																{invForm[
																	'equipe_investigacao_data'
																]
																	? invForm[
																			'equipe_investigacao_data'
																		][
																			index
																		][
																			'nome_completo'
																		]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.equipe_investigacao_data[
																		index
																	]
																		.nome_completo ===
																	'NÃO PREENCHIDO'
																		? ''
																		: invForm
																				.equipe_investigacao_data[
																				index
																			]
																				.nome_completo
																}
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'equipe_investigacao_data'
																}
																name='nome_completo'
																className='text-base leading-8  w-full h-full  sm:px-0 px-1 sm:h-fit font-normal'
																onInput={(e) =>
																	handleEquipe(
																		e.target
																			.id,
																		e.target
																			.name,
																		e.target
																			.value ??
																			'',
																	)
																}></input>
														)}
													</div>
													<div
														className={` w-[30%] border-[1px] border-black border-t-[2px] px-2 py-1 ${
															formLayout === true
																? `break-all pb-2`
																: `overflow-auto`
														}`}>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ||
														formLayout === true ||
														autorized === false ? (
															<div className='text-center'>
																{invForm[
																	'equipe_investigacao_data'
																]
																	? invForm[
																			'equipe_investigacao_data'
																		][
																			index
																		][
																			'cargo'
																		]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.equipe_investigacao_data[
																		index
																	].cargo ===
																	'NÃO PREENCHIDO'
																		? ''
																		: invForm
																				.equipe_investigacao_data[
																				index
																			]
																				.cargo
																}
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'equipe_investigacao_data'
																}
																name='cargo'
																className='text-base leading-8  w-full h-full  sm:px-0 px-1 sm:h-fit font-normal'
																onInput={(e) =>
																	handleEquipe(
																		e.target
																			.id,
																		e.target
																			.name,
																		e.target
																			.value ??
																			'',
																	)
																}></input>
														)}
													</div>
													<div
														className={` w-[30%] border-[1px] border-black border-t-[2px] px-2 py-1 ${
															formLayout === true
																? `break-all pb-2`
																: `overflow-auto`
														}`}>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ||
														formLayout === true ||
														autorized === false ? (
															<div className='text-center'>
																{invForm[
																	'equipe_investigacao_data'
																]
																	? invForm[
																			'equipe_investigacao_data'
																		][
																			index
																		][
																			'setor'
																		]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.equipe_investigacao_data[
																		index
																	].setor ===
																	'NÃO PREENCHIDO'
																		? ''
																		: invForm
																				.equipe_investigacao_data[
																				index
																			]
																				.setor
																}
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'equipe_investigacao_data'
																}
																name='setor'
																className='text-base leading-8  w-full h-full  sm:px-0 px-1 sm:h-fit font-normal'
																onInput={(e) =>
																	handleEquipe(
																		e.target
																			.id,
																		e.target
																			.name,
																		e.target
																			.value ??
																			'',
																	)
																}></input>
														)}
													</div>
													<div
														className={` w-[30%] border-[1px] border-black border-t-[2px] px-2 py-1 ${
															formLayout === true
																? `break-all pb-2`
																: `overflow-auto`
														}`}>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ||
														formLayout === true ||
														autorized === false ? (
															<div className='text-center'>
																{invForm[
																	'equipe_investigacao_data'
																]
																	? invForm[
																			'equipe_investigacao_data'
																		][
																			index
																		][
																			'email'
																		]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.equipe_investigacao_data[
																		index
																	].email ===
																	'emptyemail@gmail.com'
																		? ''
																		: invForm
																				.equipe_investigacao_data[
																				index
																			]
																				.email
																}
																type='email'
																id={`${index} / equipe_investigacao_data`}
																name='email'
																className='text-base leading-8 w-full h-full sm:px-0 px-1 sm:h-fit font-normal'
																onBlur={(e) => {
																	const email =
																		e.target
																			.value;
																	const emailRegex =
																		/^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regex para validar email

																	// se o email for inválido e não for "NÃO PREENCHIDO"
																	if (
																		!emailRegex.test(
																			email,
																		) &&
																		email !==
																			'NÃO PREENCHIDO'
																	) {
																		handleEquipe(
																			e
																				.target
																				.id,
																			e
																				.target
																				.name,
																			'', // valor "interno" salvo
																		);
																		setEmailAlert(
																			true,
																		);

																		// ⚡ regra especial: se o campo for da cronologia,
																		// enviar `emptyemail@gmail.com` no form mas manter input vazio
																		if (
																			e.target.id.includes(
																				'cronologia_incidentes_data',
																			)
																		) {
																			handleEquipe(
																				e
																					.target
																					.id,
																				e
																					.target
																					.name,
																				'emptyemail@gmail.com', // valor "interno" salvo
																			);

																			// mantém o input vazio para o usuário
																			e.target.value =
																				'';
																		}
																	} else {
																		// email válido, segue fluxo normal
																		handleEquipe(
																			e
																				.target
																				.id,
																			e
																				.target
																				.name,
																			email,
																		);
																	}
																}}
															/>
														)}
													</div>
												</div>
											</div>
										),
									)}
									{emailAlert ? (
										<div
											className='fixed inset-0 flex items-center justify-center bg-black/50 z-50 '
											onClick={() =>
												setEmailAlert(false)
											}>
											<div
												className='shadow-lg flex flex-col text-center bg-[#e7e7e7] text-[#a3a3a3] gap-8 font-semibold font-inter w-[350px] h-[180px] px-4 rounded-xl'
												onClick={(e) =>
													e.stopPropagation()
												}>
												<div className=''></div>
												<>
													<p className='text-[#a3a3a3] ont text-xl'>
														Email incorreto,
														preencha o campo
														corretamente
													</p>
													<div className='w-full text-[#bd3434] flex justify-center scale-[300%]'>
														<MdOutlineDoNotDisturbAlt />
													</div>
												</>
											</div>
										</div>
									) : null}
									{notificacao?.status === 'CLASSIFICADO' &&
									autorized === true ? (
										<div>
											<button
												className={`${
													formLayout
														? 'hidden '
														: 'absolute my-1 font-inter transition duration-200 hover:text-blue-500  border-[1px] border-[#b8b8b8] text-[#525252] rounded px-2 py-[1px]   bg-white text-[13px] shadow-sm'
												}`}
												id='adcionar'
												onClick={(e) => {
													addEquipe(e.target.id);
												}}>
												{' '}
												Adicionar{' '}
											</button>
											<button
												className={`${
													formLayout
														? 'hidden '
														: 'absolute my-1 font-inter transition duration-200 hover:text-blue-500  border-[1px] border-[#b8b8b8] text-[#525252] rounded px-2 py-[1px]  bg-white text-[13px] shadow-sm ml-20'
												}`}
												id='remover'
												onClick={(e) => {
													addEquipe(e.target.id);
												}}>
												{' '}
												Remover{' '}
											</button>
										</div>
									) : null}
								</div>
							) : null}

							{((notificacao?.status === 'CLASSIFICADO' &&
								cards.card === cards.caso) ||
								notificacao?.status === 'INVESTIGADO' ||
								notificacao?.status === 'CONCLUIDO') &&
							concluido === false ? (
								<div className='w-full my-5 border-[1px]  border-black'>
									<div className='w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold'>
										COLETA E ORGANIZAÇÃO DOS DADOS
										<p
											className={`${
												formLayout
													? 'text-sm pb-4'
													: 'text-sm'
											}`}>
											{
												'(usar metodologia apropriada - entrevistas, consulta a prontuários ou documentos que a instituição possua, busca ativa em campo, entre outros)'
											}
										</p>
									</div>

									{notificacao?.status === 'CLASSIFICADO' ? (
										<textarea
											id='coleta_dados'
											defaultValue={
												invForm?.coleta_dados ===
												'NÃO PREENCHIDO'
													? ''
													: invForm?.coleta_dados
											}
											className='p-2 w-full h-36 mt-2 text-md text-gray-700 border-none focus:outline-none focus:ring-0 resize-none'
											placeholder='Definição do cenário:'
											type='text'
											name='coleta_dados'
											onInput={(e) =>
												handleColeta(
													e.target.id,
													e.target.name,
													e.target.value ?? '',
												)
											}></textarea>
									) : (
										<div
											className={`p-4 w-full h-full ${
												formLayout === true
													? `overflow-none break-all`
													: `overflow-auto`
											}`}>
											{invForm.coleta_dados}
										</div>
									)}
								</div>
							) : null}
							{((notificacao?.status === 'CLASSIFICADO' &&
								cards.card === cards.caso) ||
								notificacao?.status === 'INVESTIGADO' ||
								notificacao?.status === 'CONCLUIDO') &&
							concluido === false ? (
								<div className='w-full my-5 border-[1px] mb-10 border-black'>
									<div
										className={`${
											formLayout
												? 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold pb-4'
												: 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold'
										}`}>
										CRONOLOGIA DO INCIDENTE
									</div>
									<div className='grid'>
										<div className='w-full flex'>
											<div className='w-[30%] text-center border-[1px] border-black font-semibold break-all text-[10px] py-2 sm:text-[14px]'>
												EVENTO
											</div>
											<div className='w-[30%] text-center border-[1px] border-black font-semibold break-all text-[10px] py-2 sm:text-[14px]'>
												DATA
											</div>
											<div className='w-[30%] text-center border-[1px] border-black font-semibold break-all text-[10px] py-2 sm:text-[14px]'>
												HORA
											</div>
											<div className='w-[30%] text-center border-[1px] border-black font-semibold break-all text-[10px] py-2 sm:text-[14px]'>
												LOCAL/SETOR
											</div>
											<div className='w-[30%] text-center border-[1px] border-black font-semibold break-all text-[10px] py-2 sm:text-[14px]'>
												DESCRIÇÃO
											</div>
										</div>
									</div>

									{Array.from({ length: cronCounter }).map(
										(_, index) => (
											<div
												key={`${index}-${'australopitecus'}`}
												className='flex'>
												<div className='min-h-[30px] h-auto w-full flex'>
													<div
														className={`${
															formLayout === true
																? `break-all`
																: ``
														} border-[1px] border-black text-center  font-normal sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-[30%] overflow-auto px-2 items-center content-center`}>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ||
														formLayout === true ||
														autorized === false ? (
															<div className=''>
																{invForm[
																	'cronologia_incidentes_data'
																]
																	? invForm[
																			'cronologia_incidentes_data'
																		][
																			index
																		][
																			'evento'
																		]
																	: null}
															</div>
														) : (
															<input
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'cronologia_incidentes_data'
																}
																name='evento'
																maxLength={244}
																className='text-base px-2 leading-8 sm:w-[100%] w-[100%] font-normal'
																defaultValue={
																	invForm
																		.cronologia_incidentes_data[
																		index
																	].evento ===
																	'NÃO PREENCHIDO'
																		? ''
																		: invForm
																				.cronologia_incidentes_data[
																				index
																			]
																				.evento
																}
																onInput={(e) =>
																	handleCronologia(
																		e.target
																			.id,
																		e.target
																			.name,
																		e.target
																			.value ??
																			'',
																	)
																}
															/>
														)}
													</div>
													<div
														className={`${
															formLayout === true
																? `break-all`
																: ``
														} border-[1px] border-black text-center  font-normal sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-[30%] overflow-auto px-2 items-center content-center`}>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ||
														formLayout === true ||
														autorized === false ? (
															<div className=''>
																{invForm[
																	'cronologia_incidentes_data'
																]
																	? formatDate(
																			invForm[
																				'cronologia_incidentes_data'
																			][
																				index
																			][
																				'data'
																			],
																		)
																	: null}
															</div>
														) : formLayout ? (
															<div className='font-normal'>
																{invForm
																	.cronologia_incidentes_data[
																	index
																].data ===
																'NÃO PREENCHIDO'
																	? ''
																	: invForm
																			.cronologia_incidentes_data[
																			index
																		].data}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.cronologia_incidentes_data[
																		index
																	].data ===
																	'2000-01-01'
																		? ''
																		: invForm
																				.cronologia_incidentes_data[
																				index
																			]
																				.data
																}
																type='date'
																max={
																	new Date()
																		.toISOString()
																		.split(
																			'T',
																		)[0]
																} // Define o limite máximo como hoje
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'cronologia_incidentes_data'
																}
																name='data'
																className=' leading-8 sm:w-[95%]  font-normal sm:max-w-[95%] max-w-[52px] '
																onInput={(e) =>
																	handleCronologia(
																		e.target
																			.id,
																		e.target
																			.name,
																		e.target
																			.value ??
																			'',
																	)
																}></input>
														)}
													</div>
													<div
														className={`${
															formLayout === true
																? `break-all`
																: ``
														} border-[1px] border-black text-center  font-normal sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-[30%] overflow-auto px-2 items-center content-center`}>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ||
														formLayout === true ||
														autorized === false ? (
															<div className=''>
																{invForm[
																	'cronologia_incidentes_data'
																]
																	? invForm[
																			'cronologia_incidentes_data'
																		][
																			index
																		][
																			'hora'
																		]
																			.split(
																				':',
																			)
																			.slice(
																				0,
																				2,
																			)
																			.join(
																				':',
																			)
																	: null}
															</div>
														) : formLayout ? (
															<div className='font-normal'>
																{
																	invForm
																		.cronologia_incidentes_data[
																		index
																	].hora
																}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.cronologia_incidentes_data[
																		index
																	].hora ===
																	'00:00:00'
																		? ''
																		: invForm
																				.cronologia_incidentes_data[
																				index
																			]
																				.hora
																}
																type='time'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'cronologia_incidentes_data'
																}
																name='hora'
																className='text-base leading-8 w-[100%] sm:w-[60%] font-normal'
																onInput={(e) =>
																	handleCronologia(
																		e.target
																			.id,
																		e.target
																			.name,
																		e.target
																			.value ??
																			'',
																	)
																}></input>
														)}
													</div>
													<div
														className={`${
															formLayout === true
																? `break-all`
																: ``
														} border-[1px] border-black text-center  font-normal sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-[30%] overflow-auto px-2 items-center content-center`}>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ||
														formLayout === true ||
														autorized === false ? (
															<div className=''>
																{invForm[
																	'cronologia_incidentes_data'
																]
																	? invForm[
																			'cronologia_incidentes_data'
																		][
																			index
																		][
																			'setor'
																		]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.cronologia_incidentes_data[
																		index
																	].setor ===
																	'NÃO PREENCHIDO'
																		? ''
																		: invForm
																				.cronologia_incidentes_data[
																				index
																			]
																				.setor
																}
																type='text'
																maxLength={244}
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'cronologia_incidentes_data'
																}
																name='setor'
																className='text-base leading-8 w-[95%] font-normal'
																onInput={(e) =>
																	handleCronologia(
																		e.target
																			.id,
																		e.target
																			.name,
																		e.target
																			.value ??
																			'',
																	)
																}></input>
														)}
													</div>

													<div
														className={`${
															formLayout === true
																? `break-all`
																: ``
														} border-[1px] border-black text-center  font-normal sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-[30%] overflow-auto px-2 items-center content-center`}>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ||
														formLayout === true ||
														autorized === false ? (
															<div className=''>
																{invForm[
																	'cronologia_incidentes_data'
																]
																	? invForm[
																			'cronologia_incidentes_data'
																		][
																			index
																		][
																			'descricao'
																		]
																	: null}
															</div>
														) : (
															<input
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'cronologia_incidentes_data'
																}
																placeholder='no mínimo 5 caracteres'
																name='descricao'
																defaultValue={
																	invForm
																		?.cronologia_incidentes_data?.[
																		index
																	]
																		?.descricao ===
																	'NÃO PREENCHIDO'
																		? ''
																		: invForm
																				?.cronologia_incidentes_data?.[
																				index
																			]
																				?.descricao
																}
																/* 	title={
																	invForm?.cronologia_incidentes_data?.[
																		index
																	]?.descricao?.trim()
																		.length <
																	10
																		? 'Mínimo 10 caracteres.'
																		: ''
																} */
																className={`text-base leading-8 w-full sm:w-[95%] font-normal 
																		 
																`}
																onInput={(e) =>
																	handleCronologia(
																		e.target
																			.id,
																		e.target
																			.name,
																		e.target
																			.value ??
																			'',
																	)
																}></input>
														)}
													</div>
												</div>
											</div>
										),
									)}

									{notificacao?.status === 'CLASSIFICADO' &&
									autorized === true ? (
										<div>
											<button
												className={`${
													formLayout
														? 'hidden '
														: 'absolute my-1 font-inter transition duration-200 hover:text-blue-500  border-[1px] border-[#b8b8b8] text-[#525252] rounded px-2 py-[1px]   bg-white text-[13px] shadow-sm'
												}`}
												id='adcionar'
												onClick={(e) => {
													addCronologia(e.target.id);
												}}>
												{' '}
												Adicionar{' '}
											</button>
											<button
												id='remover'
												className={`${
													formLayout
														? 'hidden '
														: 'absolute my-1 font-inter transition duration-200 hover:text-blue-500  border-[1px] border-[#b8b8b8] text-[#525252] rounded px-2 py-[1px]   bg-white text-[13px] shadow-sm ml-20'
												}`}
												onClick={(e) => {
													addCronologia(e.target.id);
												}}>
												{' '}
												Remover{' '}
											</button>
										</div>
									) : null}
								</div>
							) : null}
							{((notificacao?.status === 'CLASSIFICADO' &&
								cards.card === cards.caso) ||
								notificacao?.status === 'INVESTIGADO' ||
								notificacao?.status === 'CONCLUIDO') &&
							concluido === false ? (
								<div className='w-full mt-5 border-[1px] border-black'>
									<div
										className={`${
											formLayout
												? 'w-full bg-gray-300 py-1 border-black border-b-[1px]  text-center font-bold pb-4'
												: 'w-full bg-gray-300 py-1 border-black  text-center font-bold border-b-[1px] '
										}`}>
										DEFINIÇÃO DAS CAUSAS — FATORES QUE
										CONTRIBUÍRAM PARA O INCIDENTE
									</div>
									{/* <div className='w-full px-2  py-1 border-black border-b-2 text-start text-sm font-bold'>
								INCIDENTE :
							</div> */}
									<div className='grid'>
										<div className='min-h-[45px] h-auto w-full flex text-[10px] sm:text-[13px]'>
											<div
												className={`font-semibold text-[10px] sm:text-[14px] border-black border-[1px] align-middle content-center px-1 w-[30%] text-center ${
													formLayout ? 'pb-2' : ''
												}`}>
												FATORES DO PACIENTE
											</div>
											<div
												className={`font-semibold text-[10px] sm:text-[14px] border-black border-[1px] align-middle content-center px-1 w-[30%] text-center ${
													formLayout ? 'pb-2' : ''
												}`}>
												FATORES INDIVIDUAIS DOS
												PROFISSIONAIS
											</div>
											<div
												className={`font-semibold text-[10px] sm:text-[14px] border-black border-[1px] align-middle content-center px-1 w-[30%] text-center ${
													formLayout ? 'pb-2' : ''
												}`}>
												FATORES INDIVIDUAIS DA TAREFA OU
												ATIVIDADE
											</div>
											<div
												className={`font-semibold text-[10px] sm:text-[14px] border-black border-[1px] align-middle content-center px-1 w-[30%] text-center ${
													formLayout ? 'pb-2' : ''
												}`}>
												FATORES RELACIONADOS A
												COMUNICAÇÃO
											</div>
										</div>
									</div>

									{Array.from(
										'x'.repeat(incident1Counter),
									).map((item, index) => (
										<div className='grid '>
											<div className='h-auto  w-full flex text-[11px] sm:text-[16px] font-normal justify-center overflow-hidden'>
												<div
													className={` ${
														formLayout === true
															? `break-all`
															: ``
													} border-[1px] items-center content-center border-black w-full h-full overflow-hidden`}>
													{notificacao?.status ===
														'INVESTIGADO' ||
													notificacao?.status ===
														'CONCLUIDO' ||
													formLayout === true ? (
														<div className='w-full h-full overflow-x-auto px-2 text-center text-[12px] py-3 sm:text-[16px] items-center content-center'>
															{invForm[
																'definicao_causas_data'
															]
																? invForm[
																		'definicao_causas_data'
																	][
																		'fator_paciente'
																	]
																: null}
														</div>
													) : (
														<input
															defaultValue={
																invForm
																	?.definicao_causas_data
																	.fator_paciente ===
																'NÃO PREENCHIDO'
																	? ''
																	: invForm
																			?.definicao_causas_data
																			.fator_paciente
															}
															type='text'
															id={
																index +
																' ' +
																'/' +
																' ' +
																'definicao_causas_data'
															}
															name='fator_paciente'
															className='appearance-none  text-base leading-8 w-[95%] font-normal px-2'
															onInput={(e) =>
																handleCausas(
																	e.target.id,
																	e.target
																		.name,
																	e.target
																		.value ??
																		'',
																)
															}></input>
													)}
												</div>
												<div
													className={` ${
														formLayout === true
															? `break-all`
															: ``
													} border-[1px] items-center content-center border-black w-full h-full overflow-hidden`}>
													{notificacao?.status ===
														'INVESTIGADO' ||
													notificacao?.status ===
														'CONCLUIDO' ||
													formLayout === true ? (
														<div className='w-full h-full overflow-x-auto px-2 text-center text-[12px] py-3 sm:text-[16px] items-center content-center'>
															{invForm[
																'definicao_causas_data'
															]
																? invForm[
																		'definicao_causas_data'
																	][
																		'fator_profissional'
																	]
																: null}
														</div>
													) : (
														<input
															defaultValue={
																invForm
																	?.definicao_causas_data
																	.fator_profissional ===
																'NÃO PREENCHIDO'
																	? ''
																	: invForm
																			?.definicao_causas_data
																			.fator_profissional
															}
															type='text'
															id={
																index +
																' ' +
																'/' +
																' ' +
																'definicao_causas_data'
															}
															name='fator_profissional'
															className='appearance-none  text-base leading-8 w-[95%] font-normal px-2'
															onInput={(e) =>
																handleCausas(
																	e.target.id,
																	e.target
																		.name,
																	e.target
																		.value ??
																		'',
																)
															}></input>
													)}
												</div>
												<div
													className={` ${
														formLayout === true
															? `break-all`
															: ``
													} border-[1px] items-center content-center border-black w-full h-full overflow-hidden`}>
													{notificacao?.status ===
														'INVESTIGADO' ||
													notificacao?.status ===
														'CONCLUIDO' ||
													formLayout === true ? (
														<div className='w-full h-full overflow-x-auto px-2 text-center text-[12px] py-3 sm:text-[16px] items-center content-center'>
															{invForm[
																'definicao_causas_data'
															]
																? invForm[
																		'definicao_causas_data'
																	][
																		'fator_tarefa'
																	]
																: null}
														</div>
													) : (
														<input
															defaultValue={
																invForm
																	?.definicao_causas_data
																	.fator_tarefa ===
																'NÃO PREENCHIDO'
																	? ''
																	: invForm
																			?.definicao_causas_data
																			.fator_tarefa
															}
															type='text'
															id={
																index +
																' ' +
																'/' +
																' ' +
																'definicao_causas_data'
															}
															name='fator_tarefa'
															className='appearance-none  text-base leading-8 w-[95%] font-normal px-2'
															onInput={(e) =>
																handleCausas(
																	e.target.id,
																	e.target
																		.name,
																	e.target
																		.value ??
																		'',
																)
															}></input>
													)}
												</div>
												<div
													className={` ${
														formLayout === true
															? `break-all`
															: ``
													} border-[1px] items-center content-center border-black w-full h-full overflow-hidden`}>
													{notificacao?.status ===
														'INVESTIGADO' ||
													notificacao?.status ===
														'CONCLUIDO' ||
													formLayout === true ? (
														<div className='w-full h-full overflow-x-auto px-2 text-center text-[12px] py-3 sm:text-[16px] items-center content-center'>
															{invForm[
																'definicao_causas_data'
															]
																? invForm[
																		'definicao_causas_data'
																	][
																		'fator_comunicacao'
																	]
																: null}
														</div>
													) : (
														<input
															defaultValue={
																invForm
																	?.definicao_causas_data
																	.fator_comunicacao ===
																'NÃO PREENCHIDO'
																	? ''
																	: invForm
																			?.definicao_causas_data
																			.fator_comunicacao
															}
															type='text'
															id={
																index +
																' ' +
																'/' +
																' ' +
																'definicao_causas_data'
															}
															name='fator_comunicacao'
															className='appearance-none  text-base leading-8 w-[95%] font-normal px-2'
															onInput={(e) =>
																handleCausas(
																	e.target.id,
																	e.target
																		.name,
																	e.target
																		.value ??
																		'',
																)
															}></input>
													)}
												</div>
											</div>
										</div>
									))}
									<div className='grid '>
										<div className='h-auto w-full flex text-[10px] sm:text-[13px]'>
											<div className='border-[1px] border-black text-center  font-semibold sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-[30%]'>
												FATORES RELACIONADOS A
												EQUIPAMENTOS
											</div>
											<div className='border-[1px] border-black text-center  font-semibold sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-[30%]'>
												FATORES RELACIONADOS AO AMBIENTE
												DE TRABALHO
											</div>
											<div className='border-[1px] border-black text-center  font-semibold sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-[30%]'>
												FATORES ORGANIZACIONAIS
											</div>
											<div className='border-[1px] border-black text-center  font-semibold sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-[30%]'>
												FATORES RELACIONADOS A
												TREINAMENTO E EDUCAÇÃO
											</div>
										</div>
									</div>
									{Array.from(
										'x'.repeat(incident1Counter),
									).map((item, index) => (
										<div
											className='grid'
											key={index + item + 'u'}>
											<div
												className={`h-auto  w-full flex text-[11px] sm:text-[16px] font-normal justify-center overflow-hidden`}>
												<div
													className={`${
														formLayout === true
															? `break-all`
															: ``
													} border-[1px] items-center content-center border-black w-full h-full overflow-hidden ${
														index ===
														incident1Counter - 1
															? 'border-b-black'
															: ''
													}`}>
													{notificacao?.status ===
														'INVESTIGADO' ||
													notificacao?.status ===
														'CONCLUIDO' ||
													formLayout === true ? (
														<div className='w-full p-2 py-2 text-wrap font-normal overflow-auto text-center'>
															{invForm[
																'definicao_causas_data'
															]
																? invForm[
																		'definicao_causas_data'
																	][
																		'fator_equipamento'
																	]
																: null}
														</div>
													) : (
														<input
															defaultValue={
																invForm
																	?.definicao_causas_data
																	.fator_equipamento ===
																'NÃO PREENCHIDO'
																	? ''
																	: invForm
																			?.definicao_causas_data
																			.fator_equipamento
															}
															type='text'
															id={
																index +
																' ' +
																'/' +
																' ' +
																'definicao_causas_data'
															}
															name='fator_equipamento'
															className='appearance-none  text-base leading-8 px-2 w-full font-normal'
															onInput={(e) =>
																handleCausas(
																	e.target.id,
																	e.target
																		.name,
																	e.target
																		.value ??
																		'',
																)
															}></input>
													)}
												</div>
												<div
													className={`${
														formLayout === true
															? `break-all`
															: ``
													} border-[1px] items-center content-center border-black w-full h-full overflow-hidden ${
														index ===
														incident1Counter - 1
															? 'border-b-black'
															: ''
													}`}>
													{notificacao?.status ===
														'INVESTIGADO' ||
													notificacao?.status ===
														'CONCLUIDO' ||
													formLayout === true ? (
														<div className='w-full p-2 text-wrap font-normal overflow-auto text-center'>
															{invForm[
																'definicao_causas_data'
															]
																? invForm[
																		'definicao_causas_data'
																	][
																		'fator_ambiente'
																	]
																: null}
														</div>
													) : (
														<input
															defaultValue={
																invForm
																	?.definicao_causas_data
																	.fator_ambiente ===
																'NÃO PREENCHIDO'
																	? ''
																	: invForm
																			?.definicao_causas_data
																			.fator_ambiente
															}
															type='text'
															id={
																index +
																' ' +
																'/' +
																' ' +
																'definicao_causas_data'
															}
															name='fator_ambiente'
															className='appearance-none  text-base leading-8 px-2 w-full font-normal'
															onInput={(e) =>
																handleCausas(
																	e.target.id,
																	e.target
																		.name,
																	e.target
																		.value ??
																		'',
																)
															}></input>
													)}
												</div>
												<div
													className={`${
														formLayout === true
															? `break-all`
															: ``
													} border-[1px] items-center content-center border-black w-full h-full overflow-hidden ${
														index ===
														incident1Counter - 1
															? 'border-b-black'
															: ''
													}`}>
													{notificacao?.status ===
														'INVESTIGADO' ||
													notificacao?.status ===
														'CONCLUIDO' ||
													formLayout === true ? (
														<div className='w-full p-2 text-wrap font-normal overflow-auto text-center'>
															{invForm[
																'definicao_causas_data'
															]
																? invForm[
																		'definicao_causas_data'
																	][
																		'fator_organizacional'
																	]
																: null}
														</div>
													) : (
														<input
															defaultValue={
																invForm
																	?.definicao_causas_data
																	.fator_organizacional ===
																'NÃO PREENCHIDO'
																	? ''
																	: invForm
																			?.definicao_causas_data
																			.fator_organizacional
															}
															type='text'
															id={
																index +
																' ' +
																'/' +
																' ' +
																'definicao_causas_data'
															}
															name='fator_organizacional'
															className='appearance-none  text-base leading-8 px-2 w-full font-normal'
															onInput={(e) =>
																handleCausas(
																	e.target.id,
																	e.target
																		.name,
																	e.target
																		.value ??
																		'',
																)
															}></input>
													)}
												</div>
												<div
													className={`${
														formLayout === true
															? `break-all`
															: ``
													} border-[1px] items-center content-center border-black w-full h-full overflow-hidden ${
														index ===
														incident1Counter - 1
															? 'border-b-black'
															: ''
													}`}>
													{notificacao?.status ===
														'INVESTIGADO' ||
													notificacao?.status ===
														'CONCLUIDO' ||
													formLayout === true ? (
														<div className='w-full p-2 text-wrap font-normal overflow-auto text-center'>
															{invForm[
																'definicao_causas_data'
															]
																? invForm[
																		'definicao_causas_data'
																	][
																		'fator_treinamento'
																	]
																: null}
														</div>
													) : (
														<input
															defaultValue={
																invForm
																	?.definicao_causas_data
																	.fator_treinamento ===
																'NÃO PREENCHIDO'
																	? ''
																	: invForm
																			?.definicao_causas_data
																			.fator_treinamento
															}
															type='text'
															id={
																index +
																' ' +
																'/' +
																' ' +
																'definicao_causas_data'
															}
															name='fator_treinamento'
															className='appearance-none  text-base leading-8 px-2 w-full font-normal'
															onInput={(e) =>
																handleCausas(
																	e.target.id,
																	e.target
																		.name,
																	e.target
																		.value ??
																		'',
																)
															}></input>
													)}
												</div>
											</div>
										</div>
									))}
									{/* <button
								className='absolute font-bold text-[14px] hover:text-[#666666]'
								onClick={() =>
									incident1Counter
										? setIncident1Counter(
												incident1Counter + 1
										  )
										: null
								}>
								{' '}
								Adicionar{' '}
							</button>
							<button
								className='absolute font-bold text-[14px] ml-20  hover:text-[#666666]'
								onClick={() =>
									incident1Counter > 1
										? setIncident1Counter(
												incident1Counter - 1
										  )
										: null
								}>
								{' '}
								Remover{' '}
							</button> */}
								</div>
							) : null}

							{/* {notificacao?.status !== 'CLASSIFICADO' ? null : (
						<div>
							<button
								className='absolute font-bold text-[14px] hover:text-[#666666]'
								onClick={() =>
									incident1Counter
										? setIncident1Counter(
												incident1Counter + 1
										  )
										: null
								}>
								{' '}
								Adicionar{' '}
							</button>
							<button
								className='absolute font-bold text-[14px] ml-20  hover:text-[#666666]'
								onClick={() =>
									incident1Counter > 1
										? setIncident1Counter(
												incident1Counter - 1
										  )
										: null
								}>
								{' '}
								Remover{' '}
							</button>
						</div>
					)} */}
							{((notificacao?.status === 'CLASSIFICADO' &&
								cards.card === cards.caso) ||
								notificacao?.status === 'INVESTIGADO' ||
								notificacao?.status === 'CONCLUIDO') &&
							concluido === false ? (
								<div className='w-full my-10 border-[1px] mb-10  border-black '>
									<div
										className={`${
											formLayout
												? 'w-full bg-gray-300 py-1 border-black  text-center font-bold pb-4  border-b-[1px]'
												: 'w-full bg-gray-300 py-1 border-black text-center font-bold border-b-[1px] '
										}`}>
										PLANO DE AÇÃO
									</div>
									<div className='grid '>
										<div className='h-auto w-full flex'>
											<div className='border-[1px] border-black text-center  font-semibold sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-full break-all'>
												CAUSAS PRIORITÁRIAS
											</div>
											<div className='border-[1px] border-black text-center  font-semibold sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-full break-all'>
												AÇÕES PLANEJADAS
											</div>
											<div className='border-[1px] border-black text-center  font-semibold sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-full break-all'>
												RESPONSABILIDADE
											</div>
											<div className='border-[1px] border-black text-center  font-semibold sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-full break-all'>
												PRAZO
											</div>
											<div className='border-[1px] border-black text-center  font-semibold sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-full break-all'>
												STATUS
											</div>
										</div>
									</div>

									{Array.from('x'.repeat(planCounter)).map(
										(item, index) => (
											<div
												className='flex'
												key={index + item + 'ro'}>
												<div className='h-auto w-full flex'>
													<div
														className={`border-[1px] border-black text-center  font-normal sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-[30%] overflow-auto px-2 ${
															formLayout === true
																? `break-all`
																: ``
														}`}>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ||
														formLayout === true ||
														autorized === false ? (
															<div className='w-[]'>
																{invForm[
																	'plano_acoes_data'
																]
																	? invForm[
																			'plano_acoes_data'
																		][
																			index
																		][
																			'causas_prioritarias'
																		]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		?.plano_acoes_data[
																		index
																	]
																		?.causas_prioritarias ===
																	'NÃO PREENCHIDO'
																		? ''
																		: invForm
																				?.plano_acoes_data[
																				index
																			]
																				?.causas_prioritarias
																}
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'plano_acoes_data'
																}
																name='causas_prioritarias'
																className='appearance-none text-base leading-8 w-[95%] font-normal'
																onInput={(e) =>
																	handlePlano(
																		e.target
																			.id,
																		e.target
																			.name,
																		e.target
																			.value ??
																			'',
																	)
																}></input>
														)}
													</div>
													<div
														className={`border-[1px] border-black text-center  font-normal sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-[30%] overflow-auto px-2 ${
															formLayout === true
																? `break-all`
																: ``
														}`}>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ||
														formLayout === true ||
														autorized === false ? (
															<div className=''>
																{invForm[
																	'plano_acoes_data'
																]
																	? invForm[
																			'plano_acoes_data'
																		][
																			index
																		][
																			'acoes_planejadas'
																		]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		?.plano_acoes_data[
																		index
																	]
																		?.acoes_planejadas ===
																	'NÃO PREENCHIDO'
																		? ''
																		: invForm
																				?.plano_acoes_data[
																				index
																			]
																				?.acoes_planejadas
																}
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'plano_acoes_data'
																}
																name='acoes_planejadas'
																className='appearance-none   text-base leading-8 w-[95%] font-normal'
																onInput={(e) =>
																	handlePlano(
																		e.target
																			.id,
																		e.target
																			.name,
																		e.target
																			.value ??
																			'',
																	)
																}></input>
														)}
													</div>

													<div
														className={`border-[1px] border-black text-center  font-normal sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-[30%] overflow-auto px-2 ${
															formLayout === true
																? `break-all`
																: ``
														}`}>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ||
														formLayout === true ||
														autorized === false ? (
															<div className=''>
																{invForm[
																	'plano_acoes_data'
																]
																	? invForm[
																			'plano_acoes_data'
																		][
																			index
																		][
																			'responsavel'
																		]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		?.plano_acoes_data[
																		index
																	]
																		?.responsavel ===
																	'NÃO PREENCHIDO'
																		? ''
																		: invForm
																				?.plano_acoes_data[
																				index
																			]
																				?.responsavel
																}
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'plano_acoes_data'
																}
																name='responsavel'
																className='appearance-none  text-base leading-8 w-[95%] font-normal'
																onInput={(e) =>
																	handlePlano(
																		e.target
																			.id,
																		e.target
																			.name,
																		e.target
																			.value ??
																			'',
																	)
																}></input>
														)}
													</div>
													<div
														className={`border-[1px] border-black text-center  font-normal sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-[30%] overflow-auto px-2 ${
															formLayout === true
																? `break-all`
																: ``
														}`}>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ||
														formLayout === true ||
														autorized === false ? (
															<div className=''>
																{invForm[
																	'plano_acoes_data'
																]
																	? invForm[
																			'plano_acoes_data'
																		][
																			index
																		][
																			'prazo'
																		]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		?.plano_acoes_data[
																		index
																	]?.prazo ===
																	32767
																		? ''
																		: invForm
																				?.plano_acoes_data[
																				index
																			]
																				?.prazo
																}
																type='number'
																id={`${index} / plano_acoes_data`}
																name='prazo'
																placeholder='somente números'
																className='appearance-none text-base leading-8 w-[95%] font-normal'
																onInput={(
																	e,
																) => {
																	const prazo =
																		e.target
																			.value;
																	const maxPrazo = 32767; // Número máximo permitido
																	if (
																		parseInt(
																			prazo,
																		) >
																		maxPrazo
																	) {
																		alert(
																			`O valor do prazo não pode ser maior que ${maxPrazo}.`,
																		);
																	} else {
																		handlePlano(
																			e
																				.target
																				.id,
																			e
																				.target
																				.name,
																			e
																				.target
																				.value ??
																				'',
																		);
																	}
																}}
															/>
														)}
													</div>
													<div
														className={`border-[1px] border-black text-center font-normal sm:py-2 bold text-wrap text-[10px] sm:text-[14px] w-[30%] overflow-auto px-2 ${
															formLayout === true
																? `break-all`
																: ``
														}`}>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ||
														formLayout === true ||
														autorized === false ? (
															<div className='relative'>
																{/* status plano de acao status */}
																{editingPA !==
																invForm[
																	'plano_acoes_data'
																][index]?.id ? (
																	<>
																		<div className='transition-all duration-300 ease-in-out hover:bg-gray-50 rounded py-1 px-2'>
																			{invForm[
																				'plano_acoes_data'
																			]
																				? invForm[
																						'plano_acoes_data'
																					][
																						index
																					][
																						'status'
																					]
																						.replace(
																							/_/g,
																							' ',
																						)
																						.toLowerCase()
																						.replace(
																							/^./,
																							(
																								c,
																							) =>
																								c.toUpperCase(),
																						)
																				: null}
																		</div>

																		<button
																			onClick={() => {
																				setEditingPA(
																					invForm[
																						'plano_acoes_data'
																					][
																						index
																					]
																						?.id,
																				);
																			}}
																			title='Editar status do plano de ação'
																			className={`absolute ${(formLayout === true || cards?.caso === 'CLASSIFICADO') && 'hidden'} right-1 top-1/2 -translate-y-1/2 bg-[#204c81] hover:bg-[#13335A] text-white p-1.5 rounded-md shadow-sm transition-all  duration-200 ease-in-out  opacity-70 hover:opacity-100`}>
																			<FiEdit className='h-3.5 w-3.5' />
																		</button>
																	</>
																) : (
																	<div className='flex gap-1.5 items-center animate-fadeIn'>
																		<select
																			key={
																				invForm
																					.plano_acoes_data[
																					index
																				]
																					?.status ??
																				`idx-${index}`
																			}
																			defaultValue={
																				invForm
																					.plano_acoes_data[
																					index
																				]
																					?.status ??
																				''
																			}
																			id={`${index} / plano_acoes_data`}
																			name='status'
																			className='text-base px-2 py-1 h-full w-full text-gray-700 appearance-none font-normal border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white'
																			onChange={(
																				e,
																			) =>
																				handlePlano(
																					e
																						.target
																						.id,
																					e
																						.target
																						.name,
																					e
																						.target
																						.value,
																				)
																			}>
																			<option
																				hidden
																				disabled
																				value=''>
																				Selecione
																				o
																				status
																			</option>
																			<option value='PENDENTE'>
																				Pendente
																			</option>
																			<option value='EM_ANDAMENTO'>
																				Em
																				andamento
																			</option>
																			<option value='CONCLUIDO'>
																				Concluído
																			</option>
																			<option value='CANCELADO'>
																				Cancelado
																			</option>
																		</select>

																		<button
																			onClick={() => {
																				handleEditPAStatus(
																					invForm[
																						'plano_acoes_data'
																					][
																						index
																					]
																						?.id,
																				);
																				setEditingPA(
																					null,
																				);
																			}}
																			title='Confirmar edição'
																			className={`bg-[#32993E] hover:bg-[#1f7429] text-white px-2  rounded-md shadow-sm transition-all duration-200 ease-in-out ${formLayout === true && 'hidden'} font-bold text-lg flex-shrink-0`}>
																			✓
																		</button>
																	</div>
																)}
															</div>
														) : (
															<div className='transition-all duration-300 ease-in-out'>
																{invForm
																	.plano_acoes_data
																	?.length >
																0 ? (
																	<select
																		key={
																			invForm
																				.plano_acoes_data[
																				index
																			]
																				?.status ??
																			`idx-${index}`
																		}
																		defaultValue={
																			invForm
																				.plano_acoes_data[
																				index
																			]
																				?.status ??
																			''
																		}
																		id={`${index} / plano_acoes_data`}
																		name='status'
																		className='text-base h-[95%] w-[95%] font-normal border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white text-gray-700'
																		onChange={(
																			e,
																		) =>
																			handlePlano(
																				e
																					.target
																					.id,
																				e
																					.target
																					.name,
																				e
																					.target
																					.value,
																			)
																		}>
																		<option
																			hidden
																			disabled
																			value=''>
																			Selecione
																			o
																			status
																		</option>
																		<option value='PENDENTE'>
																			Pendente
																		</option>
																		<option value='EM_ANDAMENTO'>
																			Em
																			andamento
																		</option>
																		<option value='CONCLUIDO'>
																			Concluído
																		</option>
																		<option value='CANCELADO'>
																			Cancelado
																		</option>
																	</select>
																) : (
																	<span className='text-gray-500 italic'>
																		Carregando...
																	</span>
																)}
															</div>
														)}
													</div>

													<style jsx>{`
														@keyframes fadeIn {
															from {
																opacity: 0;
																transform: translateY(
																	-5px
																);
															}
															to {
																opacity: 1;
																transform: translateY(
																	0
																);
															}
														}
														.animate-fadeIn {
															animation: fadeIn
																0.3s ease-in-out;
														}
													`}</style>
												</div>
											</div>
										),
									)}
									{notificacao?.status === 'CLASSIFICADO' &&
									autorized === true ? (
										<div>
											<button
												className={`${
													formLayout
														? 'hidden '
														: 'absolute my-1 font-inter transition duration-200 hover:text-blue-500  border-[1px] border-[#b8b8b8] text-[#525252] rounded px-2 py-[1px]   bg-white text-[13px] shadow-sm'
												}`}
												id='adcionar'
												onClick={(event) =>
													addPlano(event.target.id)
												}>
												{' '}
												Adicionar{' '}
											</button>
											<button
												className={`${
													formLayout
														? 'hidden '
														: 'absolute my-1 font-inter transition duration-200 hover:text-blue-500  border-[1px] border-[#b8b8b8] text-[#525252] rounded px-2 py-[1px]   bg-white text-[13px] shadow-sm ml-20'
												}`}
												id='remover'
												onClick={(event) =>
													addPlano(event.target.id)
												}>
												{' '}
												Remover{' '}
											</button>
										</div>
									) : null}
								</div>
							) : null}
						</div>

						<div id='block3'>
							{((notificacao?.status === 'INVESTIGADO' &&
								cards.card === 'INVESTIGADO' &&
								cards.caso === 'NOTIFICADO') ||
								notificacao?.status === 'CONCLUIDO') &&
							notificacao?.classificacao?.descartar !== true &&
							concluido === false ? (
								<div className='w-full my-5 border-[1px]  border-black'>
									<div
										className={`${
											formLayout
												? 'w-full bg-gray-300 py-1 border-black border-b-[1px] text-center font-bold pb-4'
												: 'w-full bg-gray-300 py-1 border-black border-b-[1px] text-center font-bold'
										}`}>
										AVALIAÇÃO FINAL
									</div>

									<div className='w-full flex gap-2 py-1 text-start px-2 border-black   font-normal text-[14px] sm:text-[16px]'>
										As ações realizadas foram suficientes
										bloquear a reincidência do incidente?
										<div className='flex gap-1 content-center items-center align-middle text-[12px] sm:text-[16px]'>
											{notificacao?.status ===
											'CONCLUIDO' ? (
												// MODO VISUALIZAÇÃO
												<div className='flex items-center gap-4'>
													<div className='flex items-center gap-1'>
														<div
															className={`w-3 h-3 rounded-full border  flex items-center justify-center ${
																finalForm?.acoes_realizadas ===
																true
																	? 'bg-white border-blue-500'
																	: 'bg-transparent border-gray-500'
															}`}>
															{finalForm?.acoes_realizadas ===
																true && (
																<div className='w-2 h-2 rounded-full bg-blue-500 '></div>
															)}{' '}
														</div>
														<span>SIM</span>
													</div>
													<div className='flex items-center gap-1'>
														<div
															className={`w-3 h-3 rounded-full border  flex items-center justify-center ${
																finalForm?.acoes_realizadas ===
																false
																	? 'bg-white border-blue-500'
																	: 'bg-transparent border-gray-500'
															}`}>
															{' '}
															{finalForm?.acoes_realizadas ===
																false && (
																<div className='w-2 h-2 rounded-full bg-blue-500 '></div>
															)}
														</div>
														<span>NÃO</span>
													</div>
												</div>
											) : (
												// MODO PREENCHIMENTO
												<div className='flex items-center gap-4'>
													<label className='flex items-center gap-1'>
														<input
															type='radio'
															name='acoes_realizadas'
															id='sim'
															onChange={(e) =>
																handleFinal(
																	e.target
																		.name,
																	e.target.id,
																)
															}
															className='w-3 h-3'
														/>
														SIM
													</label>
													<label className='flex items-center gap-1'>
														<input
															type='radio'
															name='acoes_realizadas'
															id='nao'
															onChange={(e) =>
																handleFinal(
																	e.target
																		.name,
																	e.target.id,
																)
															}
															className='w-3 h-3'
														/>
														NÃO
													</label>
												</div>
											)}
										</div>
									</div>
									<div
										className={`${
											formLayout
												? 'w-full flex gap-2 py-1 text-start px-2 border-black border-b-[1px]  font-normal text-[16px] mb-4'
												: 'w-full flex gap-2 py-1 text-start px-2 border-black border-b-[1px]  font-normal text-[14px] sm:text-[16px]'
										}`}>
										Foi criado ou alterado algum padrão de
										trabalho para evitar a reincidência do
										incidente?
										<div className='flex gap-1 content-center items-center align-middle text-[12px] sm:text-[16px]'>
											{notificacao?.status ===
											'CONCLUIDO' ? (
												// MODO VISUALIZAÇÃO
												<div className='flex items-center gap-4'>
													<div className='flex items-center gap-1'>
														<div
															className={`w-3 h-3 rounded-full border flex items-center justify-center ${
																finalForm?.padrao_trabalho ===
																true
																	? 'bg-white border-blue-500'
																	: 'bg-transparent border-gray-500'
															}`}>
															{finalForm?.padrao_trabalho ===
																true && (
																<div className='w-2 h-2 rounded-full bg-blue-500'></div>
															)}
														</div>
														<span>SIM</span>
													</div>
													<div className='flex items-center gap-1'>
														<div
															className={`w-3 h-3 rounded-full border flex items-center justify-center ${
																finalForm?.padrao_trabalho ===
																false
																	? 'bg-white border-blue-500'
																	: 'bg-transparent border-gray-500'
															}`}>
															{finalForm?.padrao_trabalho ===
																false && (
																<div className='w-2 h-2 rounded-full bg-blue-500'></div>
															)}
														</div>
														<span>NÃO</span>
													</div>
												</div>
											) : (
												// MODO PREENCHIMENTO
												<div className='flex items-center gap-4'>
													<label className='flex items-center gap-1'>
														<input
															type='radio'
															name='padroes_trabalho'
															id='sim'
															onChange={(e) =>
																handleFinal(
																	e.target
																		.name,
																	e.target.id,
																)
															}
															className='w-3 h-3'
														/>
														SIM
													</label>
													<label className='flex items-center gap-1'>
														<input
															type='radio'
															name='padroes_trabalho'
															id='nao'
															onChange={(e) =>
																handleFinal(
																	e.target
																		.name,
																	e.target.id,
																)
															}
															className='w-3 h-3'
														/>
														NÃO
													</label>
												</div>
											)}
										</div>
									</div>

									{notificacao?.status === 'CONCLUIDO' ? (
										<div className='p-2 w-full h-36 mt-2 text-sm text-gray-700 border-none focus:outline-none focus:ring-0 resize-none break-words overflow-y-auto'>
											{finalForm.observacoes
												? finalForm.observacoes
												: null}
										</div>
									) : (
										<textarea
											className='p-2 w-full h-36 mt-2 text-sm text-gray-700 border-none focus:outline-none focus:ring-0 resize-none'
											placeholder='Observações:'
											name='observacoes'
											onChange={(e) => {
												handleFinal(
													e.target.name,
													e.target.value,
												);
											}}></textarea>
									)}
								</div>
							) : null}
						</div>
						<div id='block4'>
							{((notificacao?.status === 'INVESTIGADO' &&
								cards.card === 'INVESTIGADO' &&
								cards.caso === 'NOTIFICADO') ||
								notificacao?.status === 'CONCLUIDO') &&
							notificacao?.classificacao?.descartar !== true &&
							concluido === false ? (
								<div className='w-full my-5  '>
									<div
										className={`${'w-full bg-gray-300 py-1 text-center border-black border-[1px] border-b-[0px]  font-bold'}`}></div>
									<div
										className={`${'w-full flex gap-2 py-1 text-start px-2 border-black border-[1px] border-t-[0px]  font-normal text-[16px]'}`}>
										Corrigir tipo ou a classificação do
										incidente ?
										<div
											className={`flex gap-1 content-center items-center align-middle text-[12px] sm:text-[16px]`}>
											{/* SIM */}
											<input
												type='radio'
												name='reclassificacao'
												checked={
													finalForm?.tipo_incidente_final ||
													finalForm?.classificacao_final
														? true
														: notificacao.status ===
															  'CONCLUIDO'
															? false
															: reclass === true
												}
												onChange={(e) => {
													if (
														notificacao.status !==
														'CONCLUIDO'
													) {
														setReclass(true);
													}
												}}
												id='sim'
												className={`w-3 sm:w-auto ${
													formLayout
														? 'mt-3 mr-1'
														: ''
												}`}
											/>
											SIM
											{/* NÃO */}
											<input
												type='radio'
												name='reclassificacao'
												checked={
													!finalForm?.tipo_incidente_final &&
													!finalForm?.classificacao_final
														? notificacao.status ===
															'CONCLUIDO'
															? true
															: reclass === false
														: false
												}
												onChange={(e) => {
													if (
														notificacao.status !==
														'CONCLUIDO'
													) {
														setReclass(false);
														setSubReclassForm('');
													}
												}}
												id='nao'
												className={`w-3 sm:w-auto ${
													formLayout
														? 'mt-3 mr-1'
														: ''
												}`}
											/>
											NÃO
										</div>
									</div>

									<div
										className={` overflow-hidden duration-700 transition-all  ${
											reclass
												? formLayout
													? 'h-[900px]'
													: 'h-[auto] sm:h-[780px]'
												: 'h-[0px]'
										}`}>
										<div className='w-full'>
											<div className='flex flex-col gap-2 py-3  px-4 border-black border-[1px] border-t-[0] border-b-[0] '>
												<p className='font-bold text-gray-600 my-2 text-[22px]'>
													Nova Classificação
												</p>
												{classificacoes.map(
													(evento) => (
														<div
															key={
																evento.display +
																'ca'
															}
															className={`flex items-start gap-2`}>
															<input
																type='radio'
																name='option'
																checked={
																	finalForm?.classificacao_final
																		? evento.display ===
																			finalForm?.classificacao_final
																		: undefined
																}
																id='reclass'
																onChange={() =>
																	handleReclassForm(
																		evento.display,
																	)
																}
																value={
																	evento.display
																}
															/>
															<label
																htmlFor={
																	evento.display
																}
																className={`
																		flex gap-2
																`}>
																<p className='text-sm font-normal content-center'>
																	<span className='font-bold'>
																		{
																			evento.value
																		}
																		:
																	</span>{' '}
																	{
																		evento.descricao
																	}
																</p>
															</label>
														</div>
													),
												)}

												<div className='flex items-start gap-2'>
													<input
														type='radio'
														name='option'
														checked={
															finalForm?.classificacao_final
																? 'NEVER_EVENTS' ===
																	finalForm?.classificacao_final
																: undefined
														}
														id='reclass'
														value='NEVER_EVENTS'
														onChange={() =>
															handleReclassForm(
																'NEVER_EVENTS',
															)
														}
														className='mt-[4px]'
													/>
													<label
														htmlFor='never'
														className={`${
															formLayout
																? 'flex gap-2'
																: 'flex gap-2'
														}`}>
														<div className='text-sm font-normal content-center flex gap-2'>
															<span className='font-bold'>
																Never Events:
															</span>{' '}
															{finalForm?.sub_classificacao_final !==
															undefined ? (
																<div>
																	{finalForm?.sub_classificacao_final ===
																	''
																		? 'Nenhum never event'
																		: neverList?.filter(
																				(
																					item,
																					index,
																				) =>
																					item.id ===
																					finalForm?.sub_classificacao_final,
																			)[0]
																				?.nome}
																	{finalForm?.sub_classificacao_final ===
																	''
																		? 'Nenhum never event'
																		: neverList?.filter(
																				(
																					item,
																					index,
																				) =>
																					item.id ===
																					finalForm?.sub_classificacao_final,
																			)[0]
																				?.nome}
																</div>
															) : (
																<div>
																	{formLayout ? (
																		<div>
																			{
																				neverList.find(
																					(
																						item,
																						index,
																					) =>
																						item.id ===
																						subReclassForm,
																				)
																					?.nome
																			}
																		</div>
																	) : (
																		<select
																			className='w-[290px] bg-[#f0f0f0] p-1 rounded-md  '
																			onChange={
																				handleSubReclassForm
																			}
																			id='sub_reclass'>
																			<option
																				value=''
																				className=''>
																				Escolha
																				um
																				valor
																				de
																				acordo
																				com
																				o
																				evento
																			</option>
																			{neverList.map(
																				(
																					item,
																					index,
																				) => (
																					<option
																						key={
																							index +
																							'ga'
																						}
																						id='sub_reclass'
																						value={
																							item.id
																						}
																						className='flex mb-10'>
																						{
																							item?.label
																						}
																					</option>
																				),
																			)}
																		</select>
																	)}
																</div>
															)}
														</div>
													</label>
												</div>
											</div>
										</div>
										<div className='w-full border-[1px] border-t-[0px] border-black px-4 py-2'>
											<p className='font-bold text-gray-600 my-2 text-[22px]'>
												Novo tipo de incidente
											</p>
											<div
												className={`${
													formLayout
														? 'grid grid-cols-2 gap-3'
														: 'grid grid-cols-1 lg:grid-cols-2 gap-3'
												}`}>
												{tiposIncidentes.map(
													(incident, index) => (
														<label
															key={index + 'bo'}
															className='flex items-center sm:whitespace-nowrap'>
															<input
																type='radio'
																name='reclassIncidente'
																checked={
																	finalForm?.tipo_incidente_final
																		? finalForm?.tipo_incidente_final ===
																			incident.value
																		: undefined
																}
																onChange={() => {
																	setOtherFinal(
																		'',
																	);

																	handleReIncident(
																		incident.value,
																	);
																}}
																value={
																	incident.display
																}
																id={
																	incident.display
																}
																className='form-radio h-3 w-3 md:h-4 md:w-4 text-blue-600'
															/>
															<span
																className={`${
																	formLayout
																		? 'ml-2 text-gray-700 mb-2 text-base'
																		: 'ml-2 text-gray-700 text-sm md:text-base '
																}`}>
																{
																	incident.display
																}
															</span>
														</label>
													),
												)}
												<label className='flex items-center whitespace-nowrap'>
													<input
														type='radio'
														name='reclassIncidente'
														onChange={(e) =>
															handleReIncident(
																e.target.value,
															)
														}
														checked={
															finalForm?.tipo_incidente_final
																? 'OUTROS' ===
																	finalForm?.tipo_incidente_final
																: undefined
														}
														value='OUTROS'
														className='form-radio h-3 w-3 md:h-4 md:w-4 text-blue-600'
													/>
													<span className='ml-2 text-gray-700 flex items-center w-10/12 text-sm md:text-base'>
														Outro:
														{finalForm
															?.tipo_incidente_final_outros
															?.length > 0 ? (
															<div
																type='text'
																name='tipo_incidente'
																className='ml-2 w-full h-6 text-xs md:text-sm border-b-[1px] border-gray-500  focus:outline-none'>
																{
																	finalForm?.tipo_incidente_final_outros
																}
															</div>
														) : (
															reIncidentForm ===
																'OUTROS' && (
																<input
																	type='text'
																	name='reclassIncidente'
																	placeholder='máximo de 100 caracteres'
																	maxLength={
																		100
																	}
																	onChange={(
																		e,
																	) =>
																		setOtherFinal(
																			e
																				.target
																				.value,
																		)
																	}
																	className={`ml-2 w-full h-8 text-xs md:text-sm border-b-[1px] border-gray-500 px-2 focus:outline-none 
													`}
																/>
															)
														)}
													</span>
												</label>
											</div>
										</div>
									</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
			)}

			{!enviado && (
				<div className='flex justify-between sm:flex-row flex-col  mx-auto w-full sm:max-w-[1130px] max-w-[100vw] mt-10 px-4 sm:px-6 lg:px-8'>
					<div className='flex mt-10 sm:mt-0 flex-col sm:items-start items-center'>
						<button
							onClick={handleInvalid}
							className={` sm:max-h-[40px] h-auto max-h-[40px] transition-all duration-200 focus:outline-none font-medium w-[200px]  sm:w-[330px] justify-center ${
								textBox
									? 'enabled:bg-[#963F3D] text-[#ffffff]  flex gap-2  bg-[#d3d3d3] py-2 px-4 rounded-md enabled:hover:bg-[#7A3B3A] '
									: 'enabled:bg-[#963F3D] enabled:hover:border-0 enabled:border-[1px] text-[#ffffff] enabled:border-[#dbdbdb] border-[#f1f1f1] border-[1px]  flex gap-2  py-2 px-4 rounded-md enabled:hover:bg-[#7A3B3A] '
							} ${
								cards.card === 'NOTIFICADO' &&
								cards.caso === 'NOTIFICADO' &&
								notificacao?.status === 'NOTIFICADO'
									? ''
									: 'hidden'
							}`}>
							{'Encerrar Notificação'}
						</button>

						<button
							onClick={() => handleSaveInv()}
							disabled={formSalvo}
							className={`relative sm:max-h-[40px] h-auto max-h-[40px] transition-all duration-200 focus:outline-none font-medium  sm:w-[330px] justify-center ${
								textBoxSend
									? 'enabled:bg-[#004A80] text-[#ffffff] enabled:text-[#f7f7f7] flex gap-2  bg-[#d3d3d3] py-2 px-4 rounded-md enabled:hover:bg-[#1d4563] enabled:hover:text-[#f0f0f0]'
									: 'enabled:bg-[#fcfcfc] enabled:hover:border-0 enabled:border-[1px] enabled:border-[#dbdbdb] border-[#f1f1f1] border-[1px] text-[#E3E3E3] enabled:text-[#757575] flex gap-2  py-2 px-4 rounded-md enabled:hover:bg-[#a8a8a8] enabled:hover:text-[#ffffff]'
							} ${
								cards.card === 'CLASSIFICADO' &&
								cards.caso === 'CLASSIFICADO' &&
								autorized === true
									? ''
									: 'hidden'
							}`}>
							{carregando ? (
								<svg
									aria-hidden='true'
									className='w-5 h-5 text-gray-200 animate-spin  my-auto  fill-blue-600'
									viewBox='0 0 100 101'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'>
									<path
										d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
										fill='currentColor'
									/>
									<path
										d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
										fill='currentFill'
									/>
								</svg>
							) : formSalvo ? (
								'Alterações Salvas!'
							) : (
								'Salvar Alterações'
							)}
						</button>

						{alerta && (
							<div className='text-red-600 font-semibold mt-2'>
								{alerta}
							</div>
						)}

						{(rejectCard === 'clicked' ||
							rejectCard === 'send') && (
							<div className='fixed inset-0 flex items-center justify-center bg-black/50 z-50'>
								<div className='shadow-lg flex flex-col  text-center bg-[#e7e7e7] text-[#a3a3a3] gap-8 font-semibold font-inter w-[350px] h-[180px] px-4  rounded-xl'>
									<div className=''></div>
									{rejectCard === 'clicked' && (
										<>
											<p className='text-[#a3a3a3] text-lg'>
												Deseja Realmente Retornar esta
												notificação ao investigador?
											</p>
											<div className='flex justify-center gap-4'>
												<button
													onClick={() =>
														handleReject()
													}
													className='bg-[#004A80] rounded-md p-1 px-5 text-white hover:border-[#1b425e] border-[#004A80] border-[1px] hover:bg-[#1b425e]'>
													Sim
												</button>{' '}
												<button
													onClick={() =>
														setRejectCard('')
													}
													className='p-1 px-5 rounded-md bg-[#004A80] text-white hover:border-[#1b425e] border-[#004A80] border-[1px] hover:bg-[#1b425e]'>
													Não
												</button>
											</div>
										</>
									)}
									{rejectCard === 'send' && (
										<>
											<p>
												A notificação foi retornada com
												sucesso!
											</p>
											<a
												alt='link para retornar a pagina de avaliação de notificações'
												href='/notes-avaliation'
												className='text-[#3591d3] hover:text-[#3591d3]'>
												Retornar
											</a>
										</>
									)}
								</div>
							</div>
						)}
						<button
							onClick={() => {
								handleReject();
							}}
							className={` py-2 px-4 rounded-md  w-[300px] justify-center  max-h-[40px] transition-all duration-200 flex gap-2 focus:outline-none font-semibold ${
								rejeicao.length > 0
									? 'enabled:bg-[#ad2a28] enabled:hover:border-0 enabled:border-[1px] text-[#ffffff] enabled:border-[#dbdbdb] border-[#f1f1f1] border-[1px]  flex gap-2  py-2 px-4 rounded-md enabled:hover:bg-[#8b3634] '
									: 'enabled:bg-[#ca605f] enabled:hover:bg-[#a34745] text-[#fdfdfd]  enabled:border-[#c7c7c7] border-[1px]  bg-[#d3d3d3] hover:border-[#963F3D]  '
							} ${
								cards.card === 'INVESTIGADO' &&
								cards.caso === 'NOTIFICADO' &&
								notificacao?.status === 'INVESTIGADO'
									? ''
									: 'hidden'
							}`}>
							Retornar para Investigação
						</button>
						{textBox && (
							<div className='fixed inset-0 bg-black/40 z-30 font-inter'>
								<div
									className={`
      absolute
      left-1/2 
      bottom-[203px]
      
      translate-x-[-50%]
      transition-all 
      duration-500
      rounded-md
      flex-col 
      flex 
      gap-2 
      px-3 
      py-3
      text-sm
      font-normal
     sm:w-[500px] w-[200px] h-auto border border-[#cfcfcf] bg-white text-[#757575]
      ${
			cards.card === 'NOTIFICADO' &&
			cards.caso === 'NOTIFICADO' &&
			notificacao?.status === 'NOTIFICADO'
				? ''
				: 'hidden'
		}
    `}>
									{/* Botão de Fechar */}
									<div className='absolute top-2 right-2 text-[#b4b4b4] font-semibold z-40 text-xl hover:text-[#777777]'>
										<button
											onClick={() => {
												setTextBox(false);
												setJustificativa('');
												setEmailsList([]);
												setConcludeClass(false);
												setConcludeValue('');
												setEmailCounter(1);
											}}>
											<IoMdClose />
										</button>
									</div>

									{/* Observação */}
									<p className='mt-2 mb-2 text-start text-[16px] font-normal'>
										{' '}
										<p className=' text-center text-xl font-semibold mb-2'>
											Encerrar Notificação
										</p>
										Para encerrar a notificação nesta etapa
										sem que ela passe pela investigação,
										preencha os campos abaixo e clique em
										concluir.
									</p>
									<div className='py-2 px-1 w-full border-[#E3E3E3] border-[1px] rounded-md'>
										<p className='px-2 text-[#757575]'>
											Observação:
										</p>
										<textarea
											placeholder='Insira sua observação aqui'
											onChange={(e) => {
												setJustificativa(
													e.target.value,
												);
												setJustAlert(false);
											}}
											value={justificativa}
											className={`
        text-[12px] sm:text-[15px]
        px-2 py-2
        rounded-md
        resize-none
        w-full
        transition-all
        focus:outline-none
        ${
			justAlert
				? 'placeholder:text-[#B74644]'
				: 'placeholder:text-[#E3E3E3]'
		}
      `}
										/>
									</div>

									{/* Lista de e-mails e inputs */}
									{textBox && (
										<div className='flex flex-col gap-1 '>
											<div className='text-[#afafaf] sm:text-[14px] text-[12px]'>
												Encaminhar para:
											</div>

											{Array(emailCounter)
												.fill(0)
												.map((_, index) => (
													<div
														key={index + _ + 'moca'}
														className='flex gap-1'>
														<input
															onChange={(e) => {
																handleEmails(
																	index,
																	e.target
																		.value,
																);
																setEmailsAlert(
																	false,
																);
															}}
															type='text'
															placeholder='Digite o E-mail'
															className={`
                  rounded-md
                  w-[100%]
                  px-2 py-3
                  text-[14px]
                  placeholder:text-[11px] sm:placeholder:text-[14px]
                  transition-all
                  border
                  ${
						emailsAlert
							? 'border-[#B74644] placeholder:text-[#B74644]'
							: 'border-[#dfdfdf]'
					}
                `}
														/>
														<div className='h-auto content-center items-center align-middle'>
															<button
																onClick={() =>
																	addConcludes()
																}
																className={`border flex justify-center items-center align-middle rounded-md w-[30px] h-[30px] text-lg text-[#757575] hover:text-[#666666] hover:bg-[#e9e9e9]`}>
																<GoPlus />
															</button>
														</div>
													</div>
												))}
											{/* Lista de e-mails adicionados */}

											{emailsLoad ? (
												<svg
													aria-hidden='true'
													className='w-5 h-5 text-gray-200 animate-spin  my-auto  fill-blue-600'
													viewBox='0 0 100 101'
													fill='none'
													xmlns='http://www.w3.org/2000/svg'>
													<path
														d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
														fill='currentColor'
													/>
													<path
														d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
														fill='currentFill'
													/>
												</svg>
											) : (
												<div className='flex flex-wrap gap-2 mt-2 px-1 text-[12px] text-[#004A80]'>
													{emailsList.map(
														(item, index) => (
															<div
																className='flex gap-1 bg-[#F4F4F4] py-1 px-2 rounded-md border border-[#E3E3E3]'
																key={
																	index +
																	item +
																	'fila'
																}>
																{item}
																<button
																	onClick={() =>
																		removeEmail(
																			item,
																			index,
																		)
																	}
																	className='flex justify-center items-center text-[#B74644] bg-[#FCFCFC] hover:bg-[#e6e6e6] border border-gray-200 w-[20px] h-[20px] text-[14px] rounded-md'>
																	<IoMdClose />
																</button>
															</div>
														),
													)}
												</div>
											)}
											<div className='flex gap-3 mt-3'>
												<p className='text-[16px] mb-2  text-[#888888]'>
													Deseja acrescentar
													classificação ?{' '}
												</p>
												<div className='flex gap-1 h-[20px]'>
													Sim
													<input
														onChange={(e) =>
															handleConcludeClass(
																e.target.id,
															)
														}
														type='radio'
														id='sim'
														name='conclude-radio'></input>
												</div>
												<div className='flex gap-1 h-[20px]'>
													Não
													<input
														defaultChecked={
															concludeClass ===
															false
														}
														onChange={(e) => {
															setConcludeValue(
																'',
															);
															handleConcludeClass(
																e.target.id,
															);
														}}
														type='radio'
														id='nao'
														name='conclude-radio'></input>
												</div>
											</div>
											{textBox && concludeClass && (
												<div className='px-1 text-[#a0a0a0]'>
													<label className='flex gap-2'>
														<input
															type='radio'
															onChange={(e) => {
																setConcludeValue(
																	e.target.id,
																);
															}}
															name='class-conclude'
															id='CIRCUNSTANCIA_DE_RISCO'></input>
														<p className='font-semibold'>
															Circunstância de
															risco
														</p>
													</label>
													<label className='flex gap-2'>
														<input
															type='radio'
															onChange={(e) => {
																setConcludeValue(
																	e.target.id,
																);
															}}
															name='class-conclude'
															id='NEAR_MISS'></input>
														<p className='font-semibold'>
															Near miss
														</p>
													</label>
													<label className='flex gap-2'>
														<input
															type='radio'
															onChange={(e) => {
																setConcludeValue(
																	e.target.id,
																);
															}}
															name='class-conclude'
															id='NENHUM'></input>
														<p className='font-semibold'>
															Nenhum
														</p>
													</label>
												</div>
											)}

											<div className='w-full flex justify-center mt-4'>
												{/* 		{console.log(
													'aqui',

													justificativa.length > 3 &&
														emailsList.length > 0 &&
														((concludeClass ===
															true &&
															concludeValue.length >
																0) ||
															concludeClass ===
																false)
												)} */}
												<button
													disabled={
														!(
															justificativa.length >
																3 &&
															emailsList.length >
																0 &&
															((concludeClass ===
																true &&
																concludeValue.length >
																	0) ||
																concludeClass ===
																	false)
														)
													}
													onClick={(e) => {
														const button =
															e.currentTarget;
														button.disabled = true;
														button.innerText =
															'Enviado';
														handleInvalid(); // se quiser continuar executando a função original
													}}
													className='px-6 py-2 border-[#E3E3E3] border-[1px] text-md font-semibold rounded-md text-[#cfcfcf]
    transition-all duration-400
    enabled:text-[#ffffff]
    enabled:bg-[#004A80] enabled:hover:bg-[#1a3f5a]'>
													Concluir
												</button>
											</div>
											<div className='h-[7px] mt-2 w-full bg-[#246fa5] rounded-b'></div>
										</div>
									)}
								</div>
							</div>
						)}

						<div className='relative my-2'>
							<div
								className={`absolute top-2 right-2 text-[#b4b4b4] font-semibold z-40 hover:text-[#777777] ${
									textReject ? '' : 'hidden'
								}`}>
								<button
									onClick={() => {
										setTextReject(false);
										setRejeicao('');
									}}>
									<IoMdClose />
								</button>
							</div>
							<textarea
								type='text'
								placeholder='Justificativa'
								onChange={(e) => setRejeicao(e.target.value)}
								value={rejeicao}
								className={`enabled:bg-[#f5f5f5] text-[#a3a3a3] enabled:text-[#929292] text-sm flex gap-2 bg-[#dadada]   rounded-md   transition-all duration-500 focus:outline-none resize-none font-semibold 
								${textReject ? 'py-2 px-4 w-[300px] h-[200px]' : 'w-[300px] h-[0px] py-0 px-0'}
								${
									cards.card === 'INVESTIGADO' &&
									cards.caso === 'NOTIFICADO' &&
									notificacao?.status === 'INVESTIGADO'
										? ''
										: 'hidden'
								}`}></textarea>
						</div>
					</div>
					<div className='flex justify-start sm:items-start items-center sm:gap-0   text-red-500  flex-col'>
						{showAlert && (
							<div className='font-semibold w-[50%] leading-5'>
								Por favor, preencha todos os campos
								obrigatórios.
							</div>
						)}
						<button
							className={`enabled:bg-[#E3E3E3] max-h-[40px] text-[#a3a3a3] enabled:text-[#757575] flex gap-2 bg-[#d3d3d3]   py-2 px-4 rounded-md enabled:hover:bg-[#757575] enabled:hover:text-[#f0f0f0] transition-all duration-200 focus:outline-none font-semibold ${
								cards.card === 'NOTIFICADO' &&
								cards.caso === 'NOTIFICADO'
									? 'hidden'
									: cards.card === 'INVESTIGADO' &&
										  cards.caso === 'NOTIFICADO' &&
										  notificacao?.status === 'CONCLUIDO'
										? ''
										: cards.card === 'INVESTIGADO' &&
											  cards.caso === 'NOTIFICADO'
											? 'hidden'
											: cards.card === 'CLASSIFICADO' &&
												  cards.caso ===
														'CLASSIFICADO' &&
												  autorized === true
												? 'hidden'
												: ''
							}`}
							onClick={() => {
								handleGeneratePDF('download');
							}}>
							<div className='flex h-full scale-[130%] mt-1'>
								<FaRegFilePdf />
							</div>
							PDF
						</button>
						{/* 	<button
							onClick={() => console.log(invForm)}
							className='border-[1px] border-gray-500 p-2'>
							mostrar inv
						</button> */}

						<button
							onClick={() => {
								if (setorEdited !== false) {
									handleSubmit();
								} else {
									const el =
										document.getElementById(
											'id_setor_edit',
										);
									if (el) {
										el.scrollIntoView({
											behavior: 'smooth',
											block: 'start',
										});
									}
								}
							}}
							disabled={isButtonEnabled}
							className={` sm:max-h-[40px] h-auto max-h-[40px] transition-all duration-200 focus:outline-none font-medium  sm:w-[330px] justify-center ${
								textBoxSend
									? `enabled:border-[1px]  enabled:border-gray-200 text-[#ffffff]  flex gap-2 bg-[#003F6D] py-2 px-4 rounded-md enabled:hover:bg-[rgb(29,69,99)] enabled:hover:text-[#f0f0f0] ${
											buttonLoading &&
											'px-[93px] sm:px-[0px]'
										}`
									: 'enabled:bg-[#003F6D] bg-[#4286b8] enabled:hover:border-0 enabled:border-[1px] enabled:border-[#1d4563] border-[#f1f1f1] border-[1px]  text-[#E3E3E3] enabled:text-white flex gap-2  py-2 px-4 rounded-md enabled:hover:bg-[#1d4563] enabled:hover:text-[#ffffff]'
							} ${
								(cards.card === 'INVESTIGADO' &&
									cards.caso === 'NOTIFICADO' &&
									notificacao?.status === 'CONCLUIDO') ||
								(cards.card !== cards.caso &&
									!(
										cards.card === 'INVESTIGADO' &&
										cards.caso === 'NOTIFICADO'
									))
									? 'hidden'
									: ''
							}`}>
							{!buttonLoading ? (
								`Enviar para ${
									cards.card === 'NOTIFICADO' &&
									cards.caso === 'NOTIFICADO'
										? 'Investigação'
										: cards.card === 'CLASSIFICADO' &&
											  cards.caso === 'CLASSIFICADO'
											? 'Avaliação final'
											: 'Conclusão'
								}`
							) : (
								<svg
									aria-hidden='true'
									className='w-5 h-5 text-gray-200 animate-spin  my-auto  fill-blue-600'
									viewBox='0 0 100 101'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'>
									<path
										d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
										fill='currentColor'
									/>
									<path
										d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
										fill='currentFill'
									/>
								</svg>
							)}
						</button>

						{reclass === true &&
							(reclassForm.length === 0 ||
								(reclassForm === 'NEVER_EVENTS' &&
									subReclassForm.length === 0) ||
								(reclassForm === '' &&
									subReclassForm.length > 0) ||
								reIncidentForm.length === 0 ||
								(reIncidentForm === 'OUTROS' &&
									otherFinal === '')) &&
							finalForm?.classificacao_final === undefined &&
							notificacao.status !== 'CONCLUIDO' && (
								<p className='text-red-500 w-full my-5 font-semibold text-center'>
									Selecione a classificação e o incidente
								</p>
							)}

						<div className=''>
							<div
								className={`enabled:text-[#929292] flex-col text-sm flex gap-2 rounded-sm rounded-t-none transition-all duration-500 focus:outline-none resize-none font-semibold 
								
								${
									cards.card === 'NOTIFICADO' &&
									cards.caso === 'NOTIFICADO' &&
									notificacao?.status === 'NOTIFICADO'
										? ''
										: 'hidden'
								}`}>
								<div
									className={`flex flex-col gap-3 font-normal text-[#a1a1a1] transition-all duration-800 ${
										textBoxSend
											? 'w-[200px] sm:w-auto h-auto px-3  py-3'
											: 'w-[300px] h-0 px-3 py-0 overflow-hidden'
									}`}>
									{/* <div className='flex flex-col gap-1'>
										Encaminhar para investigador?
										<div className='flex gap-2'>
											<label className='flex gap-2'>
												<input
													onChange={() => {
														setYesCheck(false);
														setInvestigadorList([]);
													}}
													type='radio'
													id='encaminhar'
													name='encaminhar'
													value='nao'></input>
												Não
											</label>
											<label className='flex gap-2'>
												<input
													onChange={() => {
														setYesCheck(true);
														requestUsers();
													}}
													type='radio'
													id='encaminhar'
													name='encaminhar'
													value='sim'></input>
												Sim
											</label>
										</div>
										{noInvsAlert && yesCheck === false && (
											<div className='text-red-500 font-semibold text-[12px]'>
												{' '}
												Não existem investigadores
												cadastrados nesta unidade.
											</div>
										)}
									</div> */}
									{sendBox && (
										<div className=' fixed inset-0 bg-black/40 z-30 font-inter'>
											<div
												className={`
							absolute
							left-1/2 
							bottom-[203px]
							
							translate-x-[-50%]
							transition-all 
							duration-500
							rounded-md
							flex-col 
							flex 
							gap-2 
							px-3 
							py-3
							text-sm
							font-normal
						sm:w-[400px] w-[200px] h-auto border border-[#cfcfcf] bg-white text-[#757575]
								
						
							
						`}>
												<div className='absolute top-2 right-2 text-[#b4b4b4]  font-semibold z-40 text-xl hover:text-[#777777]'>
													<button
														onClick={() => {
															setSendBox('');
															setInvestigadorList(
																[],
															);
															setinvNamesList([]);
														}}>
														<IoMdClose />
													</button>
												</div>

												{/* Observação */}
												<p className='mt-2 mb-2 text-start text-[16px] font-normal'>
													{' '}
													<p className=' text-center text-xl font-semibold mb-2'>
														Enviar para Investigador
													</p>
													Para prosseguir com a
													Notificação, escolha os
													investigadores que serão
													responsaveis pelo processo
													de investigação e clique em
													enviar.
												</p>
												<p className='text-[#757575]'>
													Encaminhar para:
												</p>
												<div className='flex  gap-1'>
													<select
														className={`border-[1px] p-2 transition-all duration-200 w-[87%]  text-[#c4c4c4] border-gray-100 rounded-[4px] ${
															invAlert
																? 'border-red-500'
																: 'border-gray-200'
														}`}
														onChange={(e) => {
															handleInvSelected(
																e.target.value,
																e.target
																	.options[
																	e.target
																		.selectedIndex
																].text,
															);
														}}>
														<option
															value=''
															className=''>
															Selecione o
															Investigador
														</option>

														{invUsers
															?.sort((a, b) =>
																a.nome.localeCompare(
																	b.nome,
																),
															)
															?.map(
																(
																	user,
																	index,
																) => (
																	<option
																		className='text-gray-400'
																		key={
																			index +
																			user +
																			'mw'
																		}
																		value={
																			user?.email
																		}>
																		{
																			user?.nome
																		}
																	</option>
																),
															)}
													</select>

													<div className='flex flex-col justify-center'>
														<button
															onClick={() =>
																addInv()
															}
															className={`border-[1px] [#8f8f8f] rounded-[8px] px-1 h-[30px] w-[30px] items-center text-[#757575] ${investigadorList} align-middle text-[20px] content-center my-auto font-bold hover:text-[#666666] hover:bg-[#e9e9e9]
                          hover:border-[#e9e9e9] transition-all duration-200`}>
															<GoPlus />
														</button>
													</div>
												</div>

												{/* <button
													onClick={() =>
														console.log(invForm)
													}
													className='border-[1px] border-gray-500 p-2'>
													mostrar inv
												</button> */}

												{/* Renderizando a lista de investigadores atualizada */}
												{!isLoading ? (
													<div className='flex flex-wrap gap-2 mt-2 px-1 text-[12px]  text-[#004A80]'>
														{invNamesList.map(
															(item, index) => (
																<div
																	className='flex gap-1 bg-[#F4F4F4] py-1 px-2 rounded-[8px] border-[#E3E3E3] border-[1px]'
																	key={
																		index +
																		item +
																		'mi'
																	}>
																	{item}
																	<button
																		onClick={() => {
																			removeInv(
																				item,
																				index,
																			);
																		}}
																		className='items-center content-center text-center flex justify-center text-[#B74644] bg-[#FCFCFC] hover:bg-[#e6e6e6] border-[1px] border-gray-200 w-[20px] h-[20px] text-[14px] rounded-md'>
																		<IoMdClose />
																	</button>
																</div>
															),
														)}
													</div>
												) : (
													<svg
														aria-hidden='true'
														className='w-5 h-5 text-gray-200 animate-spin  my-auto  fill-blue-600'
														viewBox='0 0 100 101'
														fill='none'
														xmlns='http://www.w3.org/2000/svg'>
														<path
															d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
															fill='currentColor'
														/>
														<path
															d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
															fill='currentFill'
														/>
													</svg>
												)}
												<button
													disabled={
														!invNamesList.length > 0
													}
													onClick={(e) => {
														const button =
															e.currentTarget;
														button.disabled = true;
														button.innerText =
															'Enviado';
														handleSubmit(); // se quiser continuar executando a função original
													}}
													className={`px-6 py-2 border-[#E3E3E3] border-[1px] mt-8 text-md font-semibold mx-auto w-[70%] rounded-md text-[#cfcfcf]
    transition-all duration-400
    enabled:text-[#ffffff]
    enabled:bg-[#004A80] enabled:hover:bg-[#1a3f5a]
		`}>
													Enviar
												</button>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default ClassInvForm;
